package com.anjuros.website.redesign.util

import com.anjuros.website.components.language.Language
import com.anjuros.website.components.language.ResKeyType

/** Every text used by the redesigned pages. Read them with LocalText(RdText.X). */
enum class RdText : ResKeyType {
    // Navigation
    NAV_DESIGNS, NAV_TRADES, NAV_PORTAL, NAV_SEO, NAV_PRICING, NAV_ABOUT, NAV_FAQ, NAV_BLOG,
    NAV_GET_STARTED, NAV_GET_STARTED_ARROW, NAV_MENU, NAV_CLOSE, NAV_MAIN_LABEL, LOGO_ALT,

    // Template toolbar
    TOOLBAR_ALL_TEMPLATES, TOOLBAR_BACK_LABEL, TOOLBAR_ABOUT_DESIGN, TOOLBAR_PREVIEW_LABEL, TOOLBAR_PREVIEW_WITH,
    TOOLBAR_EXAMPLE_CONTENT, TOOLBAR_YOUR_DETAILS, TOOLBAR_GET_WEBSITE, TOOLBAR_PILL,
    TOOLBAR_HINT_TITLE, TOOLBAR_HINT_TEXT, TOOLBAR_HINT_BUTTON,
    TOOLBAR_LOGO_TOP, TOOLBAR_LOGO_BOTTOM, TOOLBAR_HOME_LABEL, TOOLBAR_MORE_LABEL, TOOLBAR_LINK_HOME,

    // Footer
    FOOTER_TAGLINE, FOOTER_DESIGNS, FOOTER_SERVICES, FOOTER_COMPANY,
    FOOTER_ELECTRICIAN, FOOTER_DECORATOR, FOOTER_HANDYMAN, FOOTER_ALL_DESIGNS,
    FOOTER_PRICING, FOOTER_PORTAL, FOOTER_SEO, FOOTER_CONTACT_FORMS,
    FOOTER_ABOUT, FOOTER_BLOG, FOOTER_FAQ, FOOTER_PRIVACY,
    FOOTER_COPYRIGHT, FOOTER_STRAPLINE,

    // Home: meta
    HOME_META_TITLE, HOME_META_DESCRIPTION,

    // Home: hero
    HOME_HERO_EYEBROW, HOME_HERO_TITLE_START, HOME_HERO_TITLE_MARK, HOME_HERO_TITLE_END, HOME_HERO_LEDE,
    HOME_HERO_SEE_DESIGNS, CTA_FREE_PREVIEW,
    HOME_HERO_PORTAL_BOLD, HOME_HERO_PORTAL_TEXT, HOME_HERO_PORTAL_LINK,
    HOME_FACT1_VALUE, HOME_FACT1_LABEL, HOME_FACT2_VALUE, HOME_FACT2_LABEL, HOME_FACT3_VALUE, HOME_FACT3_LABEL,
    TRADE_DECORATORS, TRADE_DOG_WALKERS, TRADE_ELECTRICIANS, TRADE_HANDYMEN,
    TRADE_HAIRDRESSERS, TRADE_BAKERS, TRADE_INSTRUCTORS, TRADE_ALL,

    // Home: included
    HOME_INCLUDED_TITLE,
    HOME_INCLUDED_MOBILE, HOME_INCLUDED_MOBILE_TEXT,
    HOME_INCLUDED_SEO, HOME_INCLUDED_SEO_TEXT,
    HOME_INCLUDED_DOMAIN, HOME_INCLUDED_DOMAIN_TEXT,
    HOME_INCLUDED_HOSTING, HOME_INCLUDED_HOSTING_TEXT,
    HOME_INCLUDED_FORM, HOME_INCLUDED_FORM_TEXT,

    // Home: featured designs
    HOME_DESIGNS_EYEBROW, HOME_DESIGNS_TITLE, HOME_DESIGNS_LEDE, FEATURED,
    HOME_DESIGN_ELECTRICIAN, HOME_DESIGN_ELECTRICIAN_TEXT, HOME_DESIGN_ELECTRICIAN_ALT,
    HOME_DESIGN_DECORATOR, HOME_DESIGN_DECORATOR_TEXT, HOME_DESIGN_DECORATOR_ALT,
    HOME_DESIGN_HANDYMAN, HOME_DESIGN_HANDYMAN_TEXT, HOME_DESIGN_HANDYMAN_ALT,
    HOME_DESIGNS_MORE, HOME_DESIGNS_BROWSE,

    // Home: trades
    HOME_TRADES_EYEBROW, HOME_TRADES_TITLE, HOME_TRADES_LEDE, HOME_TRADES_NAV_LABEL,

    // Home: how it works
    HOME_HOW_EYEBROW, HOME_HOW_TITLE,
    HOME_STEP1_TITLE, HOME_STEP1_TEXT, HOME_STEP1_LINK,
    HOME_STEP2_TITLE, HOME_STEP2_TEXT,
    HOME_STEP3_TITLE, HOME_STEP3_TEXT,
    HOME_STEP4_TITLE, HOME_STEP4_TEXT,

    // Home: portal
    HOME_PORTAL_EYEBROW, HOME_PORTAL_TITLE, HOME_PORTAL_LEDE,
    HOME_PORTAL_TICK1, HOME_PORTAL_TICK2, HOME_PORTAL_TICK3, HOME_PORTAL_TICK4, HOME_PORTAL_TICK5,
    HOME_PORTAL_OFFER_BOLD, HOME_PORTAL_OFFER_TEXT, HOME_PORTAL_EXPLORE, HOME_PORTAL_IMAGE_ALT,

    // Home: why work with me
    HOME_WHY_EYEBROW, HOME_WHY_TITLE,
    HOME_WHY1_TITLE, HOME_WHY1_TEXT, HOME_WHY2_TITLE, HOME_WHY2_TEXT, HOME_WHY3_TITLE, HOME_WHY3_TEXT,
    HOME_WHY4_TITLE, HOME_WHY4_TEXT, HOME_WHY5_TITLE, HOME_WHY5_TEXT, HOME_WHY6_TITLE, HOME_WHY6_TEXT,
    HOME_WHY6_LINK,

    // Home: FAQ
    FAQ_EYEBROW, HOME_FAQ_TITLE, FAQ_MORE_START, FAQ_MORE_LINK,
    HOME_FAQ1_Q, HOME_FAQ1_A, HOME_FAQ2_Q, HOME_FAQ2_A, HOME_FAQ3_Q, HOME_FAQ3_A,
    HOME_FAQ4_Q, HOME_FAQ4_A, HOME_FAQ5_Q, HOME_FAQ5_A,

    // Home: contact
    HOME_CONTACT_EYEBROW, HOME_CONTACT_TITLE, HOME_CONTACT_LEDE, HOME_CONTACT_EMAIL, HOME_CONTACT_PHONE,
    HOME_CONTACT_SUCCESS_TITLE, HOME_CONTACT_SUCCESS_TEXT, HOME_CONTACT_SUCCESS_AGAIN,

    // Shared
    BREADCRUMB_LABEL, BREADCRUMB_HOME,

    // Designs: meta and hero
    DESIGNS_META_TITLE, DESIGNS_META_DESCRIPTION, DESIGNS_CRUMB,
    DESIGNS_HERO_TITLE_START, DESIGNS_HERO_TITLE_MARK, DESIGNS_HERO_LEDE, DESIGNS_HERO_BROWSE,
    DESIGNS_EQ_LABEL, DESIGNS_EQ_ANY, DESIGNS_EQ_YOURS, DESIGNS_EQ_RESULT, DESIGNS_EQ_CHIPS,
    DESIGNS_EQ_SITE_START, DESIGNS_EQ_SITE_END, DESIGNS_EQ_WORDS, DESIGNS_EQ_BUTTON,

    // Designs: included
    DESIGNS_INCLUDED_TITLE,
    DESIGNS_INCLUDED_CUSTOM, DESIGNS_INCLUDED_CUSTOM_TEXT,
    DESIGNS_INCLUDED_MOBILE, DESIGNS_INCLUDED_MOBILE_TEXT,
    DESIGNS_INCLUDED_HANDBUILT, DESIGNS_INCLUDED_HANDBUILT_TEXT,
    DESIGNS_INCLUDED_FAST, DESIGNS_INCLUDED_FAST_TEXT,

    // Designs: catalogue
    DESIGNS_CAT_EYEBROW, DESIGNS_CAT_TITLE, DESIGNS_CAT_LEDE,
    DESIGNS_FILTER_LABEL, DESIGNS_FILTER_ALL, DESIGNS_FILTER_TRADES, DESIGNS_FILTER_BEAUTY, DESIGNS_FILTER_FOOD, DESIGNS_FILTER_LOCAL,
    DESIGNS_ALSO_SUITS, DESIGNS_COUNT_ALL, DESIGNS_COUNT_SOME,
    CAT_ELECTRICIAN, CAT_ELECTRICIAN_TEXT, CAT_ELECTRICIAN_ALT, CAT_ELECTRICIAN_ALSO, CAT_ELECTRICIAN_LINK,
    CAT_DECORATOR, CAT_DECORATOR_TEXT, CAT_DECORATOR_ALT, CAT_DECORATOR_ALSO, CAT_DECORATOR_LINK,
    CAT_HANDYMAN, CAT_HANDYMAN_TEXT, CAT_HANDYMAN_ALT, CAT_HANDYMAN_ALSO, CAT_HANDYMAN_LINK,
    CAT_HAIRDRESSER, CAT_HAIRDRESSER_TEXT, CAT_HAIRDRESSER_ALT, CAT_HAIRDRESSER_ALSO, CAT_HAIRDRESSER_LINK,
    CAT_DOG_WALKER, CAT_DOG_WALKER_TEXT, CAT_DOG_WALKER_ALT, CAT_DOG_WALKER_ALSO, CAT_DOG_WALKER_LINK,
    CAT_BAKER, CAT_BAKER_TEXT, CAT_BAKER_ALT, CAT_BAKER_ALSO, CAT_BAKER_LINK,
    CAT_INSTRUCTOR, CAT_INSTRUCTOR_TEXT, CAT_INSTRUCTOR_ALT, CAT_INSTRUCTOR_ALSO, CAT_INSTRUCTOR_LINK,
    CAT_PUB, CAT_PUB_TEXT, CAT_PUB_ALT, CAT_PUB_ALSO, CAT_PUB_LINK,

    // Designs: guide
    DESIGNS_GUIDE_EYEBROW, DESIGNS_GUIDE_TITLE,
    DESIGNS_GUIDE1_TITLE, DESIGNS_GUIDE1_TEXT,
    DESIGNS_GUIDE2_TITLE, DESIGNS_GUIDE2_ITEMS,
    DESIGNS_GUIDE3_TITLE, DESIGNS_GUIDE3_TEXT_START, DESIGNS_GUIDE3_LINK, DESIGNS_GUIDE3_TEXT_END,

    // Designs: FAQ
    DESIGNS_FAQ_TITLE,
    DESIGNS_FAQ1_Q, DESIGNS_FAQ1_A, DESIGNS_FAQ2_Q, DESIGNS_FAQ2_A, DESIGNS_FAQ3_Q, DESIGNS_FAQ3_A,
    DESIGNS_FAQ4_Q, DESIGNS_FAQ4_A, DESIGNS_FAQ5_Q, DESIGNS_FAQ5_A,

    // Designs: next step
    DESIGNS_NEXT_EYEBROW, DESIGNS_NEXT_TITLE,
    DESIGNS_NEXT1_EYEBROW, DESIGNS_NEXT1_TITLE, DESIGNS_NEXT1_TEXT,
    DESIGNS_NEXT2_EYEBROW, DESIGNS_NEXT2_TITLE, DESIGNS_NEXT2_TEXT, DESIGNS_NEXT2_BUTTON,

    // Shared calls to action
    CTA_SEE_ALL_DESIGNS,

    // Trades: meta and hero
    TRADES_META_TITLE, TRADES_META_DESCRIPTION, TRADES_CRUMB,
    TRADES_HERO_TITLE_START, TRADES_HERO_TITLE_MARK, TRADES_HERO_LEDE,
    TRADES_FIND_LABEL, TRADES_FIND_PLACEHOLDER, TRADES_SECTORS_LABEL,

    // Trades: directory
    TRADES_DIRECTORY_LABEL, TRADES_COUNT, TRADES_TRADE_PAGE, TRADES_SUGGESTED,
    SECTOR_BUILDING, SECTOR_OUTDOOR, SECTOR_BEAUTY, SECTOR_FOOD, SECTOR_LOCAL,
    GROUP_BUILDING, GROUP_BUILDING_TEXT, GROUP_OUTDOOR, GROUP_OUTDOOR_TEXT, GROUP_BEAUTY, GROUP_BEAUTY_TEXT,
    GROUP_FOOD, GROUP_FOOD_TEXT, GROUP_LOCAL, GROUP_LOCAL_TEXT,
    DESIGN_NAME_ELECTRICIAN, DESIGN_NAME_DECORATOR, DESIGN_NAME_HANDYMAN, DESIGN_NAME_ANY,
    ROW_ELECTRICIANS, ROW_ELECTRICIANS_TEXT, ROW_ELECTRICIANS_LINK, ROW_ELECTRICIANS_KEYWORDS,
    ROW_PLUMBERS, ROW_PLUMBERS_TEXT, ROW_PLUMBERS_KEYWORDS,
    ROW_HANDYMEN, ROW_HANDYMEN_TEXT, ROW_HANDYMEN_LINK, ROW_HANDYMEN_KEYWORDS,
    ROW_DECORATORS, ROW_DECORATORS_TEXT, ROW_DECORATORS_LINK, ROW_DECORATORS_KEYWORDS,
    ROW_CARPENTERS, ROW_CARPENTERS_TEXT, ROW_CARPENTERS_KEYWORDS,
    ROW_GARDENERS, ROW_GARDENERS_TEXT, ROW_GARDENERS_KEYWORDS,
    ROW_CLEANERS, ROW_CLEANERS_TEXT, ROW_CLEANERS_KEYWORDS,
    ROW_HAIRDRESSERS, ROW_HAIRDRESSERS_TEXT, ROW_HAIRDRESSERS_LINK, ROW_HAIRDRESSERS_KEYWORDS,
    ROW_INSTRUCTORS, ROW_INSTRUCTORS_TEXT, ROW_INSTRUCTORS_LINK, ROW_INSTRUCTORS_KEYWORDS,
    ROW_BAKERS, ROW_BAKERS_TEXT, ROW_BAKERS_LINK, ROW_BAKERS_KEYWORDS,
    ROW_PUBS, ROW_PUBS_TEXT, ROW_PUBS_LINK, ROW_PUBS_KEYWORDS,
    ROW_DOG_WALKERS, ROW_DOG_WALKERS_TEXT, ROW_DOG_WALKERS_LINK, ROW_DOG_WALKERS_KEYWORDS,
    ROW_OTHER, ROW_OTHER_TEXT, ROW_OTHER_KEYWORDS,
    TRADES_EMPTY_TITLE, TRADES_EMPTY_TEXT, TRADES_EMPTY_BUTTON,

    // Trades: what trade websites need
    TRADES_NEEDS_EYEBROW, TRADES_NEEDS_TITLE, TRADES_NEEDS_LEDE,
    NEED1_TITLE, NEED1_TEXT, NEED2_TITLE, NEED2_TEXT, NEED3_TITLE, NEED3_TEXT, NEED4_TITLE, NEED4_TEXT,
    NEED5_TITLE, NEED5_TEXT_START, NEED5_LINK, NEED5_TEXT_END, NEED6_TITLE, NEED6_TEXT,

    // Trades: FAQ and closing
    TRADES_FAQ_TITLE,
    TRADES_FAQ1_Q, TRADES_FAQ1_A, TRADES_FAQ2_Q, TRADES_FAQ2_A, TRADES_FAQ3_Q, TRADES_FAQ3_A,
    TRADES_FAQ4_Q, TRADES_FAQ4_A,
    TRADES_CLOSE_EYEBROW, TRADES_CLOSE_TITLE, TRADES_CLOSE_LEDE,

    // About: meta and hero
    ABOUT_META_TITLE, ABOUT_META_DESCRIPTION, ABOUT_CRUMB,
    ABOUT_HERO_TITLE_START, ABOUT_HERO_TITLE_MARK, ABOUT_HERO_TITLE_END, ABOUT_HERO_LEDE,
    ABOUT_FACT1_VALUE, ABOUT_FACT1_LABEL, ABOUT_FACT2_VALUE, ABOUT_FACT2_LABEL, ABOUT_FACT3_VALUE, ABOUT_FACT3_LABEL,
    ABOUT_PROFILE_LABEL, ABOUT_AVATAR_ALT, ABOUT_NAME, ABOUT_ROLE,
    ABOUT_BACKGROUND_LABEL, ABOUT_BACKGROUND, ABOUT_EDUCATION_LABEL, ABOUT_EDUCATION, ABOUT_COMPANY_LABEL, ABOUT_COMPANY,
    ABOUT_LINKEDIN, ABOUT_PORTFOLIO,

    // About: brands, story, principles, services, closing
    ABOUT_BRANDS_LABEL, ABOUT_BRANDS_TITLE, ABOUT_BRANDS,
    ABOUT_QUOTE, ABOUT_QUOTE_CAPTION, ABOUT_STORY_EYEBROW, ABOUT_STORY_TITLE,
    ABOUT_WHY_TITLE, ABOUT_WHY_TEXT, ABOUT_BACKGROUND_TITLE, ABOUT_BACKGROUND_TEXT1, ABOUT_BACKGROUND_TEXT2,
    ABOUT_WHO_TITLE, ABOUT_WHO_TEXT_START, ABOUT_WHO_LINK, ABOUT_WHO_TEXT_END,
    ABOUT_WORK_EYEBROW, ABOUT_WORK_STATUS, ABOUT_WORK_TITLE, ABOUT_WORK_CHALLENGE_LABEL, ABOUT_WORK_CHALLENGE,
    ABOUT_WORK_RESULT_LABEL, ABOUT_WORK_RESULT, ABOUT_WORK_TAGS, ABOUT_WORK_LINK, ABOUT_WORK_SHOTS_LABEL,
    ABOUT_WORK_LAPTOP_ALT, ABOUT_WORK_PHONE_ALT,
    ABOUT_PRINCIPLES_EYEBROW, ABOUT_PRINCIPLES_TITLE, ABOUT_PRINCIPLES_LEDE,
    PRINCIPLE1_TITLE, PRINCIPLE1_TEXT, PRINCIPLE2_TITLE, PRINCIPLE2_TEXT, PRINCIPLE3_TITLE, PRINCIPLE3_TEXT,
    PRINCIPLE4_TITLE, PRINCIPLE4_TEXT, PRINCIPLE5_TITLE, PRINCIPLE5_TEXT, PRINCIPLE6_TITLE, PRINCIPLE6_TEXT,
    ABOUT_SERVICES_EYEBROW, ABOUT_SERVICES_TITLE,
    SERVICE1_TITLE, SERVICE1_TEXT, SERVICE1_LINK, SERVICE2_TITLE, SERVICE2_TEXT, SERVICE2_LINK,
    SERVICE3_TITLE, SERVICE3_TEXT, SERVICE3_LINK, SERVICE4_TITLE, SERVICE4_TEXT, SERVICE4_LINK,
    ABOUT_CLOSE_EYEBROW, ABOUT_CLOSE_TITLE, ABOUT_CLOSE_LEDE, ABOUT_CLOSE_WORK, ABOUT_CLOSE_DESIGNS,

    // SEO: meta and hero
    SEO_META_TITLE, SEO_META_DESCRIPTION, SEO_CRUMB,
    SEO_HERO_TITLE_START, SEO_HERO_TITLE_MARK, SEO_HERO_LEDE, SEO_HERO_INCLUDED,
    SEO_SERP_EXAMPLE, SEO_SERP_TAG, SEO_SERP_SITE, SEO_SERP_NOTES, SEO_SERP_EXAMPLE1, SEO_SERP_EXAMPLE2, SEO_SERP_EXAMPLE3, SEO_SERP_EXAMPLE4,

    // SEO: definition, included, certificate
    SEO_TERM, SEO_TERM_FULL, SEO_DEFINE_TITLE, SEO_DEFINE_TEXT,
    SEO_INCLUDED_EYEBROW, SEO_INCLUDED_TITLE, SEO_INCLUDED_LEDE,
    SEO_CHECK1_TITLE, SEO_CHECK1_TEXT, SEO_CHECK2_TITLE, SEO_CHECK2_TEXT, SEO_CHECK3_TITLE, SEO_CHECK3_TEXT,
    SEO_CHECK4_TITLE, SEO_CHECK4_TEXT, SEO_CHECK5_TITLE, SEO_CHECK5_TEXT, SEO_CHECK6_TITLE, SEO_CHECK6_TEXT,
    SEO_CHECK7_TITLE, SEO_CHECK7_TEXT, SEO_CHECK8_TITLE, SEO_CHECK8_TEXT,
    SEO_CERT_EYEBROW, SEO_CERT_TITLE, SEO_CERT_TEXT,
    SEO_CERT_COURSE_LABEL, SEO_CERT_COURSE, SEO_CERT_LENGTH_LABEL, SEO_CERT_LENGTH, SEO_CERT_DATE_LABEL, SEO_CERT_DATE,
    SEO_CERT_VERIFY, SEO_CERT_ALT,

    // SEO: statement, benefits, ongoing
    SEO_STATEMENT_EYEBROW, SEO_STATEMENT_START, SEO_STATEMENT_MARK, SEO_STATEMENT_TEXT,
    SEO_BENEFITS_EYEBROW, SEO_BENEFITS_TITLE,
    SEO_BENEFIT1_TITLE, SEO_BENEFIT1_TEXT, SEO_BENEFIT2_TITLE, SEO_BENEFIT2_TEXT, SEO_BENEFIT3_TITLE, SEO_BENEFIT3_TEXT,
    SEO_BENEFIT4_TITLE, SEO_BENEFIT4_TEXT, SEO_BENEFIT5_TITLE, SEO_BENEFIT5_TEXT, SEO_BENEFIT6_TITLE, SEO_BENEFIT6_TEXT,
    SEO_ONGOING_EYEBROW, SEO_ONGOING_TITLE, SEO_ONGOING_TEXT, SEO_ONGOING_ITEMS, SEO_ONGOING_BUTTON,

    // SEO: FAQ and closing
    SEO_FAQ_TITLE,
    SEO_FAQ1_Q, SEO_FAQ1_A, SEO_FAQ2_Q, SEO_FAQ2_A, SEO_FAQ3_Q, SEO_FAQ3_A, SEO_FAQ4_Q, SEO_FAQ4_A, SEO_FAQ5_Q, SEO_FAQ5_A,
    SEO_CLOSE_EYEBROW, SEO_CLOSE_TITLE, SEO_CLOSE_LEDE,

    // Portal: meta and hero
    PORTAL_META_TITLE, PORTAL_META_DESCRIPTION, PORTAL_CRUMB,
    PORTAL_HERO_TITLE_START, PORTAL_HERO_TITLE_MARK, PORTAL_HERO_LEDE, PORTAL_HERO_HOW,
    PORTAL_FREE_BOLD, PORTAL_FREE_TEXT, PORTAL_PHONE_ALT,
    PORTAL_EVENT1_TITLE, PORTAL_EVENT1_TEXT, PORTAL_EVENT2_TITLE, PORTAL_EVENT2_TEXT,
    PORTAL_EVENT3_TITLE, PORTAL_EVENT3_TEXT, PORTAL_EVENT4_TITLE, PORTAL_EVENT4_TEXT, PORTAL_EVENT_STATUSES,

    // Portal: job journey
    PORTAL_JOURNEY_EYEBROW, PORTAL_JOURNEY_TITLE, PORTAL_JOURNEY_LEDE, PORTAL_JOURNEY_PHONE_CAPTION,
    PORTAL_STAGE1_STATUS, PORTAL_STAGE1_TITLE, PORTAL_STAGE1_TEXT, PORTAL_STAGE1_ACTIONS,
    PORTAL_STAGE2_STATUS, PORTAL_STAGE2_TITLE, PORTAL_STAGE2_TEXT, PORTAL_STAGE2_ACTIONS,
    PORTAL_STAGE3_STATUS, PORTAL_STAGE3_TITLE, PORTAL_STAGE3_TEXT, PORTAL_STAGE3_ACTIONS,
    PORTAL_STAGE4_STATUS, PORTAL_STAGE4_TITLE, PORTAL_STAGE4_TEXT, PORTAL_STAGE4_ACTIONS,
    PORTAL_STAGE5_STATUS, PORTAL_STAGE5_TITLE, PORTAL_STAGE5_TEXT, PORTAL_STAGE5_ACTIONS,
    PORTAL_STAGE6_STATUS, PORTAL_STAGE6_TITLE, PORTAL_STAGE6_TEXT, PORTAL_STAGE6_ACTIONS,

    // Portal: clients, benefits, getting it, FAQ, closing
    PORTAL_CLIENTS_EYEBROW, PORTAL_CLIENTS_TITLE, PORTAL_CLIENTS_LEDE, PORTAL_CLIENTS_IMAGE_ALT,
    PORTAL_STAT1_TITLE, PORTAL_STAT1_TEXT, PORTAL_STAT2_TITLE, PORTAL_STAT2_TEXT,
    PORTAL_STAT3_TITLE, PORTAL_STAT3_TEXT, PORTAL_STAT4_TITLE, PORTAL_STAT4_TEXT,
    PORTAL_BENEFITS_EYEBROW, PORTAL_BENEFITS_TITLE,
    PORTAL_BENEFIT1_TITLE, PORTAL_BENEFIT1_TEXT, PORTAL_BENEFIT2_TITLE, PORTAL_BENEFIT2_TEXT,
    PORTAL_BENEFIT3_TITLE, PORTAL_BENEFIT3_TEXT, PORTAL_BENEFIT4_TITLE, PORTAL_BENEFIT4_TEXT,
    PORTAL_BENEFIT5_TITLE, PORTAL_BENEFIT5_TEXT, PORTAL_BENEFIT6_TITLE, PORTAL_BENEFIT6_TEXT,
    PORTAL_GET_EYEBROW, PORTAL_GET_TITLE, PORTAL_GET_LEDE, PORTAL_STEP_LABEL,
    PORTAL_GET1_TITLE, PORTAL_GET1_TEXT, PORTAL_GET2_TITLE, PORTAL_GET2_TEXT, PORTAL_GET3_TITLE, PORTAL_GET3_TEXT,
    PORTAL_GET_FOOT, PORTAL_GET_COMPARE,
    PORTAL_FAQ_TITLE,
    PORTAL_FAQ1_Q, PORTAL_FAQ1_A, PORTAL_FAQ2_Q, PORTAL_FAQ2_A, PORTAL_FAQ3_Q, PORTAL_FAQ3_A,
    PORTAL_FAQ4_Q, PORTAL_FAQ4_A, PORTAL_FAQ5_Q, PORTAL_FAQ5_A,
    PORTAL_CLOSE_EYEBROW, PORTAL_CLOSE_TITLE, PORTAL_CLOSE_LEDE,

    // Pricing: meta and hero
    PRICING_META_TITLE, PRICING_META_DESCRIPTION, PRICING_CRUMB,
    PRICING_HERO_TITLE_START, PRICING_HERO_TITLE_MARK, PRICING_HERO_LEDE,
    PRICING_FACT_WEBSITE_LABEL, PRICING_FACT_WEBSITE_BOLD, PRICING_FACT_WEBSITE_TEXT,
    PRICING_FACT_PLAN_LABEL, PRICING_FACT_PLAN_BOLD, PRICING_FACT_PLAN_TEXT,

    // Pricing: quote builder
    PRICING_BUILDER_LABEL, PRICING_STEP1_EYEBROW, PRICING_STEP1_TITLE, PRICING_STEP2_EYEBROW, PRICING_STEP2_TITLE, PRICING_STEP2_TEXT,
    PRICE_FROM, PRICE_ONE_OFF, PRICE_PER_MONTH, PRICE_PER_MONTH_SHORT,
    WEBSITE_CUSTOM_BADGE, WEBSITE_CUSTOM_TITLE, WEBSITE_CUSTOM_PRICE, WEBSITE_CUSTOM_TEXT, WEBSITE_CUSTOM_FEATURES, WEBSITE_CUSTOM_LINK,
    WEBSITE_BESPOKE_BADGE, WEBSITE_BESPOKE_TITLE, WEBSITE_BESPOKE_PRICE, WEBSITE_BESPOKE_TEXT, WEBSITE_BESPOKE_FEATURES,
    PLAN_BASIC_TITLE, PLAN_BASIC_PRICE, PLAN_BASIC_TEXT, PLAN_BASIC_FEATURES,
    PLAN_PLUS_TITLE, PLAN_PLUS_PRICE, PLAN_PLUS_TEXT, PLAN_PLUS_FEATURES,
    PLAN_FULL_BADGE, PLAN_FULL_TITLE, PLAN_FULL_PRICE, PLAN_FULL_TEXT, PLAN_FULL_FEATURES,
    PLAN_EVERYTHING_IN_BASIC, PLAN_EVERYTHING_IN_PLUS,
    QUOTE_TITLE, QUOTE_SUBTITLE, QUOTE_WEBSITE_NOTE, QUOTE_FREE_LINE, QUOTE_FREE, QUOTE_FREE_NOTE, QUOTE_PLAN_NOTE,
    QUOTE_DUE_TODAY, QUOTE_DUE_AMOUNT, QUOTE_SUMMARY_FULL, QUOTE_SUMMARY_OTHER,

    // Pricing: compare, included, FAQ, closing
    PRICING_COMPARE_EYEBROW, PRICING_COMPARE_TITLE, PRICING_COMPARE_COLUMN, PRICING_COMPARE_NOTE, PRICING_NOT_INCLUDED,
    COMPARE_GROUP_ONLINE, COMPARE_GROUP_GROWING, COMPARE_GROUP_BUSINESS,
    COMPARE_DOMAIN, COMPARE_HOSTING, COMPARE_SSL, COMPARE_BACKUPS, COMPARE_SECURITY, COMPARE_ENQUIRIES,
    UPDATE_PRICES_LABEL, UPDATE_PRICES_CLOSE, UPDATE_PRICES_TITLE, UPDATE_PRICES_LEDE, UPDATE_PRICES_ROWS, UPDATE_PRICES_NOTE,
    COMPARE_UPDATES, COMPARE_UPDATES_BASIC, COMPARE_UPDATES_PLUS, COMPARE_UPDATES_FULL, COMPARE_SEO, COMPARE_HEALTH, COMPARE_SPEED,
    COMPARE_PORTAL, COMPARE_JOBS, COMPARE_RECORDS, COMPARE_REQUESTS, COMPARE_SUPPORT,
    PRICING_INCLUDED_EYEBROW, PRICING_INCLUDED_TITLE, PRICING_INCLUDED_LEDE,
    PRICING_INC1_TITLE, PRICING_INC1_TEXT, PRICING_INC2_TITLE, PRICING_INC2_TEXT, PRICING_INC3_TITLE, PRICING_INC3_TEXT,
    PRICING_INC4_TITLE, PRICING_INC4_TEXT, PRICING_INC4_LINK,
    PRICING_FAQ_TITLE,
    PRICING_FAQ1_Q, PRICING_FAQ1_A, PRICING_FAQ2_Q, PRICING_FAQ2_A, PRICING_FAQ3_Q, PRICING_FAQ3_A,
    PRICING_FAQ4_Q, PRICING_FAQ4_A, PRICING_FAQ5_Q, PRICING_FAQ5_A,
    PRICING_CLOSE_EYEBROW, PRICING_CLOSE_TITLE, PRICING_CLOSE_LEDE,

    // Contact forms: meta and hero
    FORMS_META_TITLE, FORMS_META_DESCRIPTION, FORMS_CRUMB,
    FORMS_HERO_TITLE_START, FORMS_HERO_TITLE_MARK, FORMS_HERO_LEDE, FORMS_HERO_DEMO, FORMS_FLOW_LABEL,
    FORMS_FLOW1_TITLE, FORMS_FLOW1_TEXT, FORMS_FLOW2_TITLE, FORMS_FLOW2_TEXT,
    FORMS_FLOW3_TITLE, FORMS_FLOW3_TEXT, FORMS_FLOW4_TITLE, FORMS_FLOW4_TEXT,

    // Contact forms: demo
    FORMS_DEMO_EYEBROW, FORMS_DEMO_TITLE, FORMS_DEMO_LEDE, FORMS_DEMO_TABS_LABEL,
    FORMS_SPAM_NOTE, FORMS_SPAM_LINK, FORMS_DEMO_SUBMIT, FORMS_DEMO_SENT,
    INBOX_LABEL, INBOX_TITLE, INBOX_EXAMPLE, INBOX_SUBJECT, INBOX_TO, INBOX_NOT_ANSWERED,
    INBOX_FOOT_START, INBOX_FOOT_LINK, INBOX_FOOT_END,
    FIELD_NAME, FIELD_EMAIL, FIELD_PHONE, FIELD_MESSAGE, FIELD_NOTE,
    DEMO_NAME, DEMO_EMAIL, DEMO_PHONE,
    DEMO_GENERAL_TAB, DEMO_GENERAL_TITLE, DEMO_GENERAL_KIND, DEMO_GENERAL_BUSINESS, DEMO_GENERAL_MESSAGE,
    DEMO_ELEC_TAB, DEMO_ELEC_TITLE, DEMO_ELEC_KIND, DEMO_ELEC_BUSINESS, DEMO_ELEC_TYPE, DEMO_ELEC_TYPE_OPTIONS, DEMO_ELEC_TYPE_VALUE, DEMO_ELEC_MESSAGE,
    DEMO_HAIR_TAB, DEMO_HAIR_TITLE, DEMO_HAIR_KIND, DEMO_HAIR_BUSINESS, DEMO_HAIR_MESSAGE, DEMO_HAIR_DATE, DEMO_HAIR_DATE_VALUE,
    DEMO_PLUMB_TAB, DEMO_PLUMB_TITLE, DEMO_PLUMB_KIND, DEMO_PLUMB_BUSINESS, DEMO_PLUMB_MESSAGE, DEMO_PLUMB_URGENCY, DEMO_PLUMB_URGENCY_OPTIONS, DEMO_PLUMB_URGENCY_VALUE,
    DEMO_DECO_TAB, DEMO_DECO_TITLE, DEMO_DECO_KIND, DEMO_DECO_BUSINESS, DEMO_DECO_AREAS, DEMO_DECO_AREAS_OPTIONS, DEMO_DECO_AREAS_VALUE,
    DEMO_DECO_WORK, DEMO_DECO_WORK_OPTIONS, DEMO_DECO_WORK_VALUE, DEMO_DECO_MESSAGE,
    DEMO_BAKE_TAB, DEMO_BAKE_TITLE, DEMO_BAKE_KIND, DEMO_BAKE_BUSINESS, DEMO_BAKE_WHAT, DEMO_BAKE_WHAT_OPTIONS, DEMO_BAKE_WHAT_VALUE, DEMO_BAKE_NOTE,

    // Contact forms: field types, benefits, spam, FAQ, closing
    FORMS_FIELDS_EYEBROW, FORMS_FIELDS_TITLE, FORMS_FIELDS_LEDE, FORMS_FIELDS_LABEL,
    FIELD_TYPE_TEXT, FIELD_TYPE_TEXT_SAMPLE, FIELD_TYPE_EMAIL, FIELD_TYPE_EMAIL_SAMPLE, FIELD_TYPE_PHONE, FIELD_TYPE_PHONE_SAMPLE,
    FIELD_TYPE_AREA, FIELD_TYPE_AREA_SAMPLE, FIELD_TYPE_SELECT, FIELD_TYPE_SELECT_SAMPLE, FIELD_TYPE_DATE, FIELD_TYPE_DATE_SAMPLE,
    FIELD_TYPE_CHECK, FIELD_TYPE_CHECK_SAMPLE, FIELD_TYPE_RADIO, FIELD_TYPE_RADIO_SAMPLE,
    FORMS_BENEFITS_EYEBROW, FORMS_BENEFITS_TITLE, FORMS_BENEFITS_LEDE,
    FORMS_BENEFIT1_TITLE, FORMS_BENEFIT1_TEXT, FORMS_BENEFIT2_TITLE, FORMS_BENEFIT2_TEXT, FORMS_BENEFIT3_TITLE, FORMS_BENEFIT3_TEXT,
    FORMS_BENEFIT4_TITLE, FORMS_BENEFIT4_TEXT, FORMS_BENEFIT5_TITLE, FORMS_BENEFIT5_TEXT, FORMS_BENEFIT6_TITLE, FORMS_BENEFIT6_TEXT,
    FORMS_SPAM_EYEBROW, FORMS_SPAM_TITLE, FORMS_SPAM_TEXT1, FORMS_SPAM_TEXT2, FORMS_SPAM_LIST_TITLE, FORMS_SPAM_LIST,
    FORMS_FAQ_TITLE,
    FORMS_FAQ1_Q, FORMS_FAQ1_A, FORMS_FAQ2_Q, FORMS_FAQ2_A, FORMS_FAQ3_Q, FORMS_FAQ3_A, FORMS_FAQ4_Q, FORMS_FAQ4_A,
    FORMS_CLOSE_EYEBROW, FORMS_CLOSE_TITLE, FORMS_CLOSE_LEDE, FORMS_CLOSE_PRICING,

    // Blog: meta, hero, latest guide
    BLOG_META_TITLE, BLOG_META_DESCRIPTION, BLOG_CRUMB,
    BLOG_HERO_TITLE_START, BLOG_HERO_TITLE_MARK, BLOG_HERO_LEDE, BLOG_TOPICS_LABEL, BLOG_TOPICS,
    BLOG_LATEST, BLOG_LATEST_READ, BLOG_READ_TIME,

    // Blog: guides, closing
    BLOG_GUIDES_EYEBROW, BLOG_GUIDES_TITLE, BLOG_GUIDES_LEDE, BLOG_INSIDE, BLOG_READ_ARTICLE,
    BLOG_TOPIC_WEBSITES, BLOG_TOPIC_CUSTOMERS,
    BLOG_WHY_WEBSITE_ALT, BLOG_WHY_WEBSITE_INSIDE, BLOG_FEATURES_ALT, BLOG_FEATURES_INSIDE,
    BLOG_CUSTOMERS_ALT, BLOG_CUSTOMERS_INSIDE, BLOG_COST_ALT, BLOG_COST_INSIDE,
    BLOG_CLOSE_EYEBROW, BLOG_CLOSE_TITLE, BLOG_CLOSE_LEDE, BLOG_CLOSE_DESIGNS,

    // Blog articles
    BLOG_WHY_WEBSITE_META_TITLE, BLOG_WHY_WEBSITE_META_DESCRIPTION, BLOG_FEATURES_META_TITLE, BLOG_FEATURES_META_DESCRIPTION,
    BLOG_CUSTOMERS_META_TITLE, BLOG_CUSTOMERS_META_DESCRIPTION, BLOG_COST_META_TITLE, BLOG_COST_META_DESCRIPTION,
    BLOG_BY_START, BLOG_BY_NAME, BLOG_BY_END, BLOG_TOC_TITLE, BLOG_GET_IN_TOUCH, BLOG_MORE_EYEBROW, BLOG_MORE_TITLE, TABLE_SWIPE,

    // FAQ page
    FAQS_META_TITLE, FAQS_META_DESCRIPTION, FAQS_CRUMB, FAQS_HERO_TITLE_START, FAQS_HERO_TITLE_MARK, FAQS_HERO_LEDE,
    FAQS_SEARCH_LABEL, FAQS_SEARCH_PLACEHOLDER, FAQS_TOPICS_LABEL, FAQS_NO_RESULTS_START, FAQS_NO_RESULTS_LINK,
    FAQS_NO_RESULTS_END, FAQS_TOPIC_START, FAQS_TOPIC_WEBSITE, FAQS_TOPIC_SEO, FAQS_TOPIC_ENQUIRIES,
    FAQS_TOPIC_ENQUIRIES_SHORT, FAQS_TOPIC_PLANS, FAQS_LINK_TRADES, FAQS_LINK_DESIGNS, FAQS_LINK_WHY_WEBSITE,
    FAQS_LINK_SEO, FAQS_LINK_FORMS, FAQS_LINK_PORTAL, FAQS_LINK_PRICING, FAQS_Q1, FAQS_A1, FAQS_Q2, FAQS_A2, FAQS_Q3,
    FAQS_A3, FAQS_Q4, FAQS_A4, FAQS_Q5, FAQS_A5, FAQS_Q6, FAQS_A6, FAQS_Q7, FAQS_A7, FAQS_Q8, FAQS_A8, FAQS_Q9,
    FAQS_A9, FAQS_Q10, FAQS_A10, FAQS_Q11, FAQS_A11, FAQS_Q12, FAQS_A12, FAQS_Q13, FAQS_A13,
    FAQS_Q14, FAQS_A14, FAQS_CLOSE_EYEBROW, FAQS_CLOSE_TITLE, FAQS_CLOSE_LEDE, FAQS_CLOSE_PRICING,

    // Copy buttons for contact details
    COPY_EMAIL_LABEL, COPY_WHATSAPP_LABEL, COPY_DONE;

    override val keyName: String
        get() = name
}

private val EnglishTexts: Map<RdText, String> = mapOf(
    RdText.NAV_DESIGNS to "Designs",
    RdText.NAV_TRADES to "Trades",
    RdText.NAV_PORTAL to "Job Portal",
    RdText.NAV_SEO to "SEO",
    RdText.NAV_PRICING to "Pricing",
    RdText.NAV_ABOUT to "About",
    RdText.NAV_FAQ to "FAQ",
    RdText.NAV_BLOG to "Blog",
    RdText.NAV_GET_STARTED to "Get started",
    RdText.NAV_GET_STARTED_ARROW to "Get started →",
    RdText.NAV_MENU to "Menu",
    RdText.NAV_CLOSE to "Close",
    RdText.NAV_MAIN_LABEL to "Main",
    RdText.LOGO_ALT to "Anjuros Development, website design for sole traders",

    RdText.TOOLBAR_ALL_TEMPLATES to "All designs",
    RdText.TOOLBAR_BACK_LABEL to "Back to all designs",
    RdText.TOOLBAR_ABOUT_DESIGN to "About this design",
    RdText.TOOLBAR_PREVIEW_LABEL to "Preview mode",
    RdText.TOOLBAR_PREVIEW_WITH to "Preview with",
    RdText.TOOLBAR_EXAMPLE_CONTENT to "Example content",
    RdText.TOOLBAR_YOUR_DETAILS to "Your details",
    RdText.TOOLBAR_GET_WEBSITE to "Get this website",
    RdText.TOOLBAR_PILL to "Like this design? Get this website",
    RdText.TOOLBAR_HINT_TITLE to "Preview the design two ways",
    RdText.TOOLBAR_HINT_TEXT to "Switch between Example content and Your details. {b}Example content{/b} shows a fully customised sample website to demonstrate what this design can look like, but it will be tailored with your own content for any trade or business. {b}Your details{/b} shows the same layout without the sample content, so you can focus on the design and structure.",
    RdText.TOOLBAR_HINT_BUTTON to "Got it",
    RdText.TOOLBAR_LOGO_TOP to "ANJUROS",
    RdText.TOOLBAR_LOGO_BOTTOM to "DEVELOPMENT",
    RdText.TOOLBAR_HOME_LABEL to "Anjuros Development home",
    RdText.TOOLBAR_MORE_LABEL to "More from Anjuros",
    RdText.TOOLBAR_LINK_HOME to "Home",

    RdText.FOOTER_TAGLINE to "Website design and job management for UK sole traders.",
    RdText.FOOTER_DESIGNS to "Designs",
    RdText.FOOTER_SERVICES to "Services",
    RdText.FOOTER_COMPANY to "Company",
    RdText.FOOTER_ELECTRICIAN to "Electrician websites",
    RdText.FOOTER_DECORATOR to "Decorator websites",
    RdText.FOOTER_HANDYMAN to "Handyman websites",
    RdText.FOOTER_ALL_DESIGNS to "All designs",
    RdText.FOOTER_PRICING to "Pricing",
    RdText.FOOTER_PORTAL to "Job Management Portal",
    RdText.FOOTER_SEO to "SEO services",
    RdText.FOOTER_CONTACT_FORMS to "Contact forms",
    RdText.FOOTER_ABOUT to "About",
    RdText.FOOTER_BLOG to "Blog",
    RdText.FOOTER_FAQ to "FAQ",
    RdText.FOOTER_PRIVACY to "Privacy policy",
    RdText.FOOTER_COPYRIGHT to "© 2026 Anjuros Development · Company No. 16286424",
    RdText.FOOTER_STRAPLINE to "Websites for UK sole traders",

    RdText.HOME_META_TITLE to "Website Design for UK Sole Traders | More Enquiries, Less Admin",
    RdText.HOME_META_DESCRIPTION to "Website design for UK sole traders. Trade-specific designs for electricians, decorators, handymen and more, built in about 3 days. Pay only when you're happy.",

    RdText.HOME_HERO_EYEBROW to "Website design for UK sole traders",
    RdText.HOME_HERO_TITLE_START to "A website that brings in ",
    RdText.HOME_HERO_TITLE_MARK to "more work",
    RdText.HOME_HERO_TITLE_END to " for your trade",
    RdText.HOME_HERO_LEDE to "Professional websites for electricians, decorators, handymen and every local trade. Built in about 3 days and designed to get you found on Google.",
    RdText.HOME_HERO_SEE_DESIGNS to "See the designs",
    RdText.CTA_FREE_PREVIEW to "Get a free preview",
    RdText.HOME_HERO_PORTAL_BOLD to "Plus your own Job Management Portal.",
    RdText.HOME_HERO_PORTAL_TEXT to " Website enquiries arrive as organised jobs, ready to schedule and get paid. ",
    RdText.HOME_HERO_PORTAL_LINK to "See how it works",
    RdText.HOME_FACT1_VALUE to "~3 days",
    RdText.HOME_FACT1_LABEL to "from content to live",
    RdText.HOME_FACT2_VALUE to "£0 upfront",
    RdText.HOME_FACT2_LABEL to "pay when you're happy",
    RdText.HOME_FACT3_VALUE to "10+ years",
    RdText.HOME_FACT3_LABEL to "of development experience",
    RdText.TRADE_DECORATORS to "Decorators",
    RdText.TRADE_DOG_WALKERS to "Dog walkers",
    RdText.TRADE_ELECTRICIANS to "Electricians",
    RdText.TRADE_HANDYMEN to "Handymen",
    RdText.TRADE_HAIRDRESSERS to "Hairdressers",
    RdText.TRADE_BAKERS to "Bakers",
    RdText.TRADE_INSTRUCTORS to "Instructors",
    RdText.TRADE_ALL to "All trades",

    RdText.HOME_INCLUDED_TITLE to "Every website includes",
    RdText.HOME_INCLUDED_MOBILE to "Mobile-friendly design",
    RdText.HOME_INCLUDED_MOBILE_TEXT to "Looks right on every phone",
    RdText.HOME_INCLUDED_SEO to "Local SEO setup",
    RdText.HOME_INCLUDED_SEO_TEXT to "Ready to be found on Google",
    RdText.HOME_INCLUDED_DOMAIN to "Your own domain",
    RdText.HOME_INCLUDED_DOMAIN_TEXT to "Set up and launched for you",
    RdText.HOME_INCLUDED_HOSTING to "Hosting & SSL",
    RdText.HOME_INCLUDED_HOSTING_TEXT to "Secure, backed up, kept online",
    RdText.HOME_INCLUDED_FORM to "Custom contact form",
    RdText.HOME_INCLUDED_FORM_TEXT to "Built around your enquiries",

    RdText.HOME_DESIGNS_EYEBROW to "Featured website designs",
    RdText.HOME_DESIGNS_TITLE to "Designs made for real trades",
    RdText.HOME_DESIGNS_LEDE to "Pick a design that suits your work. I customise it with your logo, colours, photos and services so it looks like your business, not a template.",
    RdText.FEATURED to "Featured",
    RdText.HOME_DESIGN_ELECTRICIAN to "Electrician website design",
    RdText.HOME_DESIGN_ELECTRICIAN_TEXT to "Services, certifications and a quote form that lands straight in your portal.",
    RdText.HOME_DESIGN_ELECTRICIAN_ALT to "Electrician website design for UK sole traders",
    RdText.HOME_DESIGN_DECORATOR to "Decorator website design",
    RdText.HOME_DESIGN_DECORATOR_TEXT to "A gallery-led layout that shows off finished rooms.",
    RdText.HOME_DESIGN_DECORATOR_ALT to "Decorator website design to showcase your work and win more jobs",
    RdText.HOME_DESIGN_HANDYMAN to "Handyman website design",
    RdText.HOME_DESIGN_HANDYMAN_TEXT to "Lists every odd job clearly, with prices if you want them.",
    RdText.HOME_DESIGN_HANDYMAN_ALT to "Handyman website design for UK sole traders",
    RdText.HOME_DESIGNS_MORE to "8 designs available, including hairdresser, baker, instructor and pub. Fully bespoke websites too.",
    RdText.HOME_DESIGNS_BROWSE to "Browse all designs",

    RdText.HOME_TRADES_EYEBROW to "Who I work with",
    RdText.HOME_TRADES_TITLE to "Websites for every local trade",
    RdText.HOME_TRADES_LEDE to "Each trade has its own page with example layouts, the content customers look for, and tips for ranking in your area.",
    RdText.HOME_TRADES_NAV_LABEL to "Website design by trade",

    RdText.HOME_HOW_EYEBROW to "How it works",
    RdText.HOME_HOW_TITLE to "Live in four steps, with nothing to pay upfront",
    RdText.HOME_STEP1_TITLE to "Choose a design",
    RdText.HOME_STEP1_TEXT to "Start from a trade design or any design you like. Everything can be tailored to your business. ",
    RdText.HOME_STEP1_LINK to "View designs",
    RdText.HOME_STEP2_TITLE to "Send your content",
    RdText.HOME_STEP2_TEXT to "I’ll tell you exactly what I need: logo, photos of your work, services and prices. Missing something? I’ll help you create it.",
    RdText.HOME_STEP3_TITLE to "Your website is built",
    RdText.HOME_STEP3_TEXT to "I set up the website and domain, usually in about 3 days. Review the preview and request changes until you’re happy, then pay.",
    RdText.HOME_STEP4_TITLE to "Manage jobs in your portal",
    RdText.HOME_STEP4_TEXT to "Enquiries from your website arrive in your Job Management Portal, ready to quote, schedule and invoice.",

    RdText.HOME_PORTAL_EYEBROW to "Job Management Portal",
    RdText.HOME_PORTAL_TITLE to "Run your business, not your paperwork",
    RdText.HOME_PORTAL_LEDE to "A simple dashboard built for sole traders. Use it at home or on the job.",
    RdText.HOME_PORTAL_TICK1 to "Website enquiries automatically become jobs",
    RdText.HOME_PORTAL_TICK2 to "Keep every customer, note and photo in one place",
    RdText.HOME_PORTAL_TICK3 to "Send “on my way” messages and review requests",
    RdText.HOME_PORTAL_TICK4 to "Get paid faster with payment links",
    RdText.HOME_PORTAL_TICK5 to "Track hours worked and monthly statistics",
    RdText.HOME_PORTAL_OFFER_BOLD to "2 months free",
    RdText.HOME_PORTAL_OFFER_TEXT to "Included with the Full Service plan",
    RdText.HOME_PORTAL_EXPLORE to "Explore the portal",
    RdText.HOME_PORTAL_IMAGE_ALT to "Job Management Portal showing a new enquiry with status, estimated cost and before and after photos",

    RdText.HOME_WHY_EYEBROW to "Why work with me",
    RdText.HOME_WHY_TITLE to "A developer who builds for sole traders",
    RdText.HOME_WHY1_TITLE to "10+ years as a developer",
    RdText.HOME_WHY1_TEXT to "Fast, reliable websites built with real technical experience.",
    RdText.HOME_WHY2_TITLE to "Mobile-first",
    RdText.HOME_WHY2_TEXT to "Most customers find you on their phone, so every layout starts there.",
    RdText.HOME_WHY3_TITLE to "Built to be found",
    RdText.HOME_WHY3_TEXT to "Clean code, fast loading and local SEO basics set up from day one.",
    RdText.HOME_WHY4_TITLE to "Designs that build trust",
    RdText.HOME_WHY4_TEXT to "Look as professional online as the work you do on site.",
    RdText.HOME_WHY5_TITLE to "Affordable",
    RdText.HOME_WHY5_TEXT to "Simple pricing focused on getting you enquiries.",
    RdText.HOME_WHY6_TITLE to "Friendly support",
    RdText.HOME_WHY6_TEXT to "Straight answers and help whenever you need a change. ",
    RdText.HOME_WHY6_LINK to "About me",

    RdText.FAQ_EYEBROW to "FAQ",
    RdText.HOME_FAQ_TITLE to "Questions sole traders ask",
    RdText.FAQ_MORE_START to "More answers on the ",
    RdText.FAQ_MORE_LINK to "full FAQ page",
    RdText.HOME_FAQ1_Q to "Are hosting and updates included?",
    RdText.HOME_FAQ1_A to "Yes. Every website comes with a care plan covering hosting, domain renewal, SSL, backups and security updates. <a href=\"/website-design-pricing-uk\">See pricing for the plans</a>.",
    RdText.HOME_FAQ2_Q to "How long does it take to build my website?",
    RdText.HOME_FAQ2_A to "Usually about 3 days once I have your content. You get a preview and can request changes before it goes live.",
    RdText.HOME_FAQ3_Q to "Do I have to pay upfront?",
    RdText.HOME_FAQ3_A to "No. You only pay once you’re happy with the finished website.",
    RdText.HOME_FAQ4_Q to "Will my website show up on Google?",
    RdText.HOME_FAQ4_A to "Yes. Every site is built so Google can find and understand it: mobile-first, fast loading, clean code and local SEO basics. The Care Plus plan adds ongoing SEO improvements to help you rank higher in your area.",
    RdText.HOME_FAQ5_Q to "Can I choose a design made for a different trade?",
    RdText.HOME_FAQ5_A to "Yes. Designs are based on common trades, but you can pick any one and I’ll tailor it to your business.",

    RdText.HOME_CONTACT_EYEBROW to "Get started",
    RdText.HOME_CONTACT_TITLE to "Ready for more enquiries?",
    RdText.HOME_CONTACT_LEDE to "Tell me about your business and which design you like. I’ll get back to you with next steps.",
    RdText.HOME_CONTACT_EMAIL to "Email",
    RdText.HOME_CONTACT_PHONE to "WhatsApp",
    RdText.HOME_CONTACT_SUCCESS_TITLE to "Thank you, your message has been sent",
    RdText.HOME_CONTACT_SUCCESS_TEXT to "I’ll get back to you with next steps as soon as possible. If it’s urgent, message me on WhatsApp.",
    RdText.HOME_CONTACT_SUCCESS_AGAIN to "Send another message",

    RdText.BREADCRUMB_LABEL to "Breadcrumb",
    RdText.BREADCRUMB_HOME to "Home",

    RdText.DESIGNS_META_TITLE to "Website Designs for UK Sole Traders | Any Design, Any Business",
    RdText.DESIGNS_META_DESCRIPTION to "Browse website designs for UK sole traders and small businesses. Pick any design, whatever your trade, and I'll tailor it to your business, services and branding.",
    RdText.DESIGNS_CRUMB to "Website designs",
    RdText.DESIGNS_HERO_TITLE_START to "Website designs for UK sole traders and ",
    RdText.DESIGNS_HERO_TITLE_MARK to "small businesses",
    RdText.DESIGNS_HERO_LEDE to "Choose the look you like, not the trade in its name. Each design is a starting point, and I tailor it to your business, services and branding.",
    RdText.DESIGNS_HERO_BROWSE to "Browse 8 designs",
    RdText.DESIGNS_EQ_LABEL to "Any design plus your business details equals your own website",
    RdText.DESIGNS_EQ_ANY to "Any design",
    RdText.DESIGNS_EQ_YOURS to "Your business",
    RdText.DESIGNS_EQ_RESULT to "Your website",
    RdText.DESIGNS_EQ_CHIPS to "Logo|Colours|Services|Photos|Prices|Your area",
    RdText.DESIGNS_EQ_SITE_START to "Your ",
    RdText.DESIGNS_EQ_SITE_END to " business",
    RdText.DESIGNS_EQ_WORDS to "plumbing|cleaning|gardening|barbering|photography|tutoring|roofing|catering",
    RdText.DESIGNS_EQ_BUTTON to "Get a quote",

    RdText.DESIGNS_INCLUDED_TITLE to "Every design includes",
    RdText.DESIGNS_INCLUDED_CUSTOM to "Fully customised",
    RdText.DESIGNS_INCLUDED_CUSTOM_TEXT to "Your branding, text and photos",
    RdText.DESIGNS_INCLUDED_MOBILE to "Mobile-friendly",
    RdText.DESIGNS_INCLUDED_MOBILE_TEXT to "Looks right on every device",
    RdText.DESIGNS_INCLUDED_HANDBUILT to "Hand-built",
    RdText.DESIGNS_INCLUDED_HANDBUILT_TEXT to "No themes or site builders",
    RdText.DESIGNS_INCLUDED_FAST to "Online fast",
    RdText.DESIGNS_INCLUDED_FAST_TEXT to "Usually live in about 3 days",

    RdText.DESIGNS_CAT_EYEBROW to "All website designs",
    RdText.DESIGNS_CAT_TITLE to "Pick a design, whatever your trade",
    RdText.DESIGNS_CAT_LEDE to "Each design is named after a profession to show how it could work for that type of business. Any design can be customised for any business, so a plumber can use the electrician design and a beautician can use the hairdresser design.",
    RdText.DESIGNS_FILTER_LABEL to "Filter designs by type of business",
    RdText.DESIGNS_FILTER_ALL to "All designs",
    RdText.DESIGNS_FILTER_TRADES to "Trades & home services",
    RdText.DESIGNS_FILTER_BEAUTY to "Beauty & wellbeing",
    RdText.DESIGNS_FILTER_FOOD to "Food & hospitality",
    RdText.DESIGNS_FILTER_LOCAL to "Pets & local services",
    RdText.DESIGNS_ALSO_SUITS to "Also suits",
    RdText.DESIGNS_COUNT_ALL to "Showing all 8 designs",
    RdText.DESIGNS_COUNT_SOME to "Showing %d of 8 designs. Any design works for any business.",

    RdText.CAT_ELECTRICIAN to "Electrician website design",
    RdText.CAT_ELECTRICIAN_TEXT to "A professional layout that presents your services clearly and turns visitors into enquiries.",
    RdText.CAT_ELECTRICIAN_ALT to "Electrician website design for UK sole traders",
    RdText.CAT_ELECTRICIAN_ALSO to "Plumbers|Gas engineers|Locksmiths|Roofers",
    RdText.CAT_ELECTRICIAN_LINK to "View electrician design",
    RdText.CAT_DECORATOR to "Decorator website design",
    RdText.CAT_DECORATOR_TEXT to "A clean, professional look built to show off your finished work and customer reviews.",
    RdText.CAT_DECORATOR_ALT to "Decorator website design to showcase your work and customer reviews",
    RdText.CAT_DECORATOR_ALSO to "Plasterers|Tilers|Carpenters|Cleaners",
    RdText.CAT_DECORATOR_LINK to "View decorator design",
    RdText.CAT_HANDYMAN to "Handyman website design",
    RdText.CAT_HANDYMAN_TEXT to "A practical layout that lists every service and makes it easy for customers to get in touch.",
    RdText.CAT_HANDYMAN_ALT to "Handyman website design for UK sole traders",
    RdText.CAT_HANDYMAN_ALSO to "Electricians|Builders|Gardeners|Joiners",
    RdText.CAT_HANDYMAN_LINK to "View handyman design",
    RdText.CAT_HAIRDRESSER to "Hairdresser website design",
    RdText.CAT_HAIRDRESSER_TEXT to "A modern layout to showcase your services, prices and portfolio of work.",
    RdText.CAT_HAIRDRESSER_ALT to "Hairdresser website design showing services, pricing and portfolio",
    RdText.CAT_HAIRDRESSER_ALSO to "Barbers|Beauticians|Nail technicians|Makeup artists",
    RdText.CAT_HAIRDRESSER_LINK to "View hairdresser design",
    RdText.CAT_DOG_WALKER to "Dog walker website design",
    RdText.CAT_DOG_WALKER_TEXT to "A playful, modern concept for dog walkers and pet sitters.",
    RdText.CAT_DOG_WALKER_ALT to "Dog walker website design for dog walkers and pet sitters",
    RdText.CAT_DOG_WALKER_ALSO to "Pet sitters|Dog groomers|Childminders|Tutors",
    RdText.CAT_DOG_WALKER_LINK to "View dog walker design",
    RdText.CAT_BAKER to "Baker website design",
    RdText.CAT_BAKER_TEXT to "A product-focused layout that shows off what you make and attracts orders.",
    RdText.CAT_BAKER_ALT to "Baker website design to showcase products and take orders",
    RdText.CAT_BAKER_ALSO to "Cake makers|Caterers|Florists|Crafters",
    RdText.CAT_BAKER_LINK to "View baker design",
    RdText.CAT_INSTRUCTOR to "Instructor website design",
    RdText.CAT_INSTRUCTOR_TEXT to "A calm, modern concept for Tai Chi, yoga and fitness instructors.",
    RdText.CAT_INSTRUCTOR_ALT to "Instructor website design for Tai Chi, yoga and fitness instructors",
    RdText.CAT_INSTRUCTOR_ALSO to "Personal trainers|Therapists|Coaches|Driving instructors",
    RdText.CAT_INSTRUCTOR_LINK to "View instructor design",
    RdText.CAT_PUB to "Pub website design",
    RdText.CAT_PUB_TEXT to "A stylish concept to showcase your menus, events and venue.",
    RdText.CAT_PUB_ALT to "Pub website design to showcase menus, events and your venue",
    RdText.CAT_PUB_ALSO to "Cafés|Restaurants|Event venues|B&Bs",
    RdText.CAT_PUB_LINK to "View pub design",

    RdText.DESIGNS_GUIDE_EYEBROW to "How designs work",
    RdText.DESIGNS_GUIDE_TITLE to "How to choose the right website design for your business",
    RdText.DESIGNS_GUIDE1_TITLE to "Choose by layout, not by trade",
    RdText.DESIGNS_GUIDE1_TEXT to "The trade names are just examples. Look for the layout that suits how you win work: a gallery if customers want to see finished jobs, a clear services list if they want to know what you do, or product photos if you sell what you make.",
    RdText.DESIGNS_GUIDE2_TITLE to "What I tailor for you",
    RdText.DESIGNS_GUIDE2_ITEMS to "Logo, colours and fonts|Business name, text and services|Photos of your work|Your area and contact details|<a href=\"/contact-forms\">Contact form</a> fields for your enquiries",
    RdText.DESIGNS_GUIDE3_TITLE to "What stays the same",
    RdText.DESIGNS_GUIDE3_TEXT_START to "The structure and layout of the design you pick. That keeps it quick and affordable. If you want something entirely different, I can build a ",
    RdText.DESIGNS_GUIDE3_LINK to "fully bespoke website",
    RdText.DESIGNS_GUIDE3_TEXT_END to " from scratch.",

    RdText.DESIGNS_FAQ_TITLE to "Questions about the designs",
    RdText.DESIGNS_FAQ1_Q to "Can I choose a design made for a different trade?",
    RdText.DESIGNS_FAQ1_A to "Yes. Each design is named after a profession only to show how it could look. An electrician can choose the handyman design, a plumber can choose the electrician design, and I’ll tailor it to your business.",
    RdText.DESIGNS_FAQ2_Q to "Will my website look the same as someone else’s?",
    RdText.DESIGNS_FAQ2_A to "No. Every design is fully customised with your logo, colours, photos and content, so your website reflects your business and looks unique to your customers.",
    RdText.DESIGNS_FAQ3_Q to "Are these templates from a website builder?",
    RdText.DESIGNS_FAQ3_A to "No. Every design is custom-built by me, not based on pre-made themes or third-party builders.",
    RdText.DESIGNS_FAQ4_Q to "What if none of the designs suit my business?",
    RdText.DESIGNS_FAQ4_A to "I can build a fully bespoke website from scratch, designed around your brand and goals.",
    RdText.DESIGNS_FAQ5_Q to "How quickly can my website go live?",
    RdText.DESIGNS_FAQ5_A to "Usually in about 3 days once I have your content. You’ll see a preview and can ask for changes before it goes live.",

    RdText.DESIGNS_NEXT_EYEBROW to "Your next step",
    RdText.DESIGNS_NEXT_TITLE to "Found a design you like?",
    RdText.DESIGNS_NEXT1_EYEBROW to "Start from a design",
    RdText.DESIGNS_NEXT1_TITLE to "I’ll customise it for your business",
    RdText.DESIGNS_NEXT1_TEXT to "Tell me which design you like and what you do. You’ll get a preview, and you only pay when you’re happy.",
    RdText.DESIGNS_NEXT2_EYEBROW to "Fully bespoke",
    RdText.DESIGNS_NEXT2_TITLE to "Want something completely custom?",
    RdText.DESIGNS_NEXT2_TEXT to "I can design and build a website from scratch, tailored to your brand and goals.",
    RdText.DESIGNS_NEXT2_BUTTON to "Discuss a bespoke website",

    RdText.CTA_SEE_ALL_DESIGNS to "See all designs",

    RdText.TRADES_META_TITLE to "Website Design for UK Trades | Electricians, Plumbers, Builders & More",
    RdText.TRADES_META_DESCRIPTION to "Website design for UK trades: electricians, plumbers, builders, decorators, gardeners and every local business. Find your trade and see which design suits you.",
    RdText.TRADES_CRUMB to "Trades",
    RdText.TRADES_HERO_TITLE_START to "Website design for UK trades and ",
    RdText.TRADES_HERO_TITLE_MARK to "local businesses",
    RdText.TRADES_HERO_LEDE to "Websites for electricians, plumbers, builders, decorators and every local trade. Built to get you found on Google, build trust and turn visitors into enquiries.",
    RdText.TRADES_FIND_LABEL to "Find your trade",
    RdText.TRADES_FIND_PLACEHOLDER to "e.g. plumber, gardener, barber",
    RdText.TRADES_SECTORS_LABEL to "Jump to a sector",

    RdText.TRADES_DIRECTORY_LABEL to "Trades I build websites for",
    RdText.TRADES_COUNT to "%d trades",
    RdText.TRADES_TRADE_PAGE to "Trade page",
    RdText.TRADES_SUGGESTED to "Suggested design",
    RdText.SECTOR_BUILDING to "Building & home",
    RdText.SECTOR_OUTDOOR to "Outdoor & cleaning",
    RdText.SECTOR_BEAUTY to "Beauty & wellbeing",
    RdText.SECTOR_FOOD to "Food & hospitality",
    RdText.SECTOR_LOCAL to "Pets & local services",
    RdText.GROUP_BUILDING to "Building & home trades",
    RdText.GROUP_BUILDING_TEXT to "Websites that show your services, areas covered and finished work.",
    RdText.GROUP_OUTDOOR to "Outdoor & cleaning",
    RdText.GROUP_OUTDOOR_TEXT to "Websites that win regular local contracts as well as one-off jobs.",
    RdText.GROUP_BEAUTY to "Beauty & wellbeing",
    RdText.GROUP_BEAUTY_TEXT to "Websites that show your style, services and how to book.",
    RdText.GROUP_FOOD to "Food & hospitality",
    RdText.GROUP_FOOD_TEXT to "Websites that make your food and venue look as good as they are.",
    RdText.GROUP_LOCAL to "Pets & local services",
    RdText.GROUP_LOCAL_TEXT to "Friendly websites that build trust with people in your area.",
    RdText.DESIGN_NAME_ELECTRICIAN to "Electrician design",
    RdText.DESIGN_NAME_DECORATOR to "Decorator design",
    RdText.DESIGN_NAME_HANDYMAN to "Handyman design",
    RdText.DESIGN_NAME_ANY to "Any of the 8 designs",
    RdText.ROW_ELECTRICIANS to "Electricians",
    RdText.ROW_ELECTRICIANS_TEXT to "Get found on Google and generate local enquiries for installations, repairs and emergency work.",
    RdText.ROW_ELECTRICIANS_LINK to "Electrician websites",
    RdText.ROW_ELECTRICIANS_KEYWORDS to "electrician electrical spark sparky",
    RdText.ROW_PLUMBERS to "Plumbers",
    RdText.ROW_PLUMBERS_TEXT to "Rank locally and bring in enquiries for installations, repairs and emergency callouts when customers need you most.",
    RdText.ROW_PLUMBERS_KEYWORDS to "plumber plumbing heating gas boiler engineer",
    RdText.ROW_HANDYMEN to "Handymen",
    RdText.ROW_HANDYMEN_TEXT to "Simple, clear websites that list your services, build trust and bring in local work quickly.",
    RdText.ROW_HANDYMEN_LINK to "Handyman websites",
    RdText.ROW_HANDYMEN_KEYWORDS to "handyman handymen odd jobs maintenance",
    RdText.ROW_DECORATORS to "Painters & decorators",
    RdText.ROW_DECORATORS_TEXT to "Showcase your work and attract residential and commercial painting jobs.",
    RdText.ROW_DECORATORS_LINK to "Decorator websites",
    RdText.ROW_DECORATORS_KEYWORDS to "decorator painter painting decorating plasterer",
    RdText.ROW_CARPENTERS to "Carpenters & builders",
    RdText.ROW_CARPENTERS_TEXT to "Display your projects and win clients for bespoke woodwork, fittings, extensions and repairs.",
    RdText.ROW_CARPENTERS_KEYWORDS to "carpenter joiner woodwork builder building kitchen fitter",
    RdText.ROW_GARDENERS to "Gardeners & landscapers",
    RdText.ROW_GARDENERS_TEXT to "Highlight your services and past work to homeowners and businesses needing regular maintenance or landscaping.",
    RdText.ROW_GARDENERS_KEYWORDS to "gardener gardening landscaper landscaping tree surgeon",
    RdText.ROW_CLEANERS to "Window cleaners & cleaners",
    RdText.ROW_CLEANERS_TEXT to "Clearly outline your services and rounds to win regular local customers.",
    RdText.ROW_CLEANERS_KEYWORDS to "window cleaner cleaning cleaners gutter domestic",
    RdText.ROW_HAIRDRESSERS to "Hairdressers & barbers",
    RdText.ROW_HAIRDRESSERS_TEXT to "Showcase your work, highlight services and attract local clients for cuts, colouring and styling.",
    RdText.ROW_HAIRDRESSERS_LINK to "Hairdresser websites",
    RdText.ROW_HAIRDRESSERS_KEYWORDS to "hairdresser hair salon barber beautician nails beauty",
    RdText.ROW_INSTRUCTORS to "Instructors & tutors",
    RdText.ROW_INSTRUCTORS_TEXT to "Present your expertise, classes and availability to connect with new students.",
    RdText.ROW_INSTRUCTORS_LINK to "Instructor websites",
    RdText.ROW_INSTRUCTORS_KEYWORDS to "instructor tutor teacher yoga fitness personal trainer tai chi coach driving",
    RdText.ROW_BAKERS to "Bakers & cake makers",
    RdText.ROW_BAKERS_TEXT to "Display your products and attract local customers looking for fresh bread, cakes and custom bakes.",
    RdText.ROW_BAKERS_LINK to "Baker websites",
    RdText.ROW_BAKERS_KEYWORDS to "baker bakery cakes cake maker caterer catering",
    RdText.ROW_PUBS to "Pubs, cafés & venues",
    RdText.ROW_PUBS_TEXT to "Showcase your menu, events and atmosphere to attract locals and visitors.",
    RdText.ROW_PUBS_LINK to "Pub websites",
    RdText.ROW_PUBS_KEYWORDS to "pub bar cafe café restaurant venue inn",
    RdText.ROW_DOG_WALKERS to "Dog walkers & pet sitters",
    RdText.ROW_DOG_WALKERS_TEXT to "Build trust with owners and win regular local clients.",
    RdText.ROW_DOG_WALKERS_LINK to "Dog walker websites",
    RdText.ROW_DOG_WALKERS_KEYWORDS to "dog walker pet sitter groomer pets animal",
    RdText.ROW_OTHER to "Any other local trader",
    RdText.ROW_OTHER_TEXT to "Versatile websites that promote your services, build trust and bring steady enquiries from your area.",
    RdText.ROW_OTHER_KEYWORDS to "local trader sole trader small business other general mobile service",
    RdText.TRADES_EMPTY_TITLE to "Your trade isn’t listed yet, and that’s fine",
    RdText.TRADES_EMPTY_TEXT to "I build websites for all UK sole traders and local businesses. Any design can be tailored to your work.",
    RdText.TRADES_EMPTY_BUTTON to "Tell me about your business",

    RdText.TRADES_NEEDS_EYEBROW to "Built for trades",
    RdText.TRADES_NEEDS_TITLE to "What every trade website needs to win local work",
    RdText.TRADES_NEEDS_LEDE to "Whatever your trade, customers look for the same things before they get in touch. Every website I build covers them.",
    RdText.NEED1_TITLE to "Found in local searches",
    RdText.NEED1_TEXT to "Built with local SEO in mind, so people searching for your trade in your area can find you.",
    RdText.NEED2_TITLE to "Easy on a phone",
    RdText.NEED2_TEXT to "Most customers search on their phone, so every page is mobile-friendly and fast to load.",
    RdText.NEED3_TITLE to "Reviews that build trust",
    RdText.NEED3_TEXT to "A customer review section shows new customers that others are happy with your work.",
    RdText.NEED4_TITLE to "Enquiry forms that work",
    RdText.NEED4_TEXT to "A <a href=\"/contact-forms\">contact form</a> designed around your jobs, so you get the details you need to quote.",
    RdText.NEED5_TITLE to "Jobs organised for you",
    RdText.NEED5_TEXT_START to "With the ",
    RdText.NEED5_LINK to "Job Management Portal",
    RdText.NEED5_TEXT_END to ", enquiries become organised jobs automatically.",
    RdText.NEED6_TITLE to "Looks like your business",
    RdText.NEED6_TEXT to "Your logo, colours and photos of your work, so it never looks like a template.",

    RdText.TRADES_FAQ_TITLE to "Trade website questions",
    RdText.TRADES_FAQ1_Q to "Do you build websites for my trade if it isn’t listed?",
    RdText.TRADES_FAQ1_A to "Yes. I build websites for all UK sole traders and local businesses. Any of my designs can be tailored to your trade.",
    RdText.TRADES_FAQ2_Q to "Will my trade website show up on Google?",
    RdText.TRADES_FAQ2_A to "Every website is built with local SEO in mind, fast loading pages and a mobile-friendly layout, to help customers in your area find you.",
    RdText.TRADES_FAQ3_Q to "Can I show the areas I cover?",
    RdText.TRADES_FAQ3_A to "Yes. Your website can list the towns and areas you work in, which also helps local searches.",
    RdText.TRADES_FAQ4_Q to "Which design should I choose for my trade?",
    RdText.TRADES_FAQ4_A to "Choose the layout you like. The suggested designs above are a good starting point, but any design can be tailored to any business.",
    RdText.TRADES_CLOSE_EYEBROW to "Don’t see your trade?",
    RdText.TRADES_CLOSE_TITLE to "I build websites for every kind of local business",
    RdText.TRADES_CLOSE_LEDE to "Explore the designs or get in touch, and I’ll create something tailored to your work.",

    RdText.ABOUT_META_TITLE to "About Anjuros Development | Website Design for UK Sole Traders",
    RdText.ABOUT_META_DESCRIPTION to "Meet the developer behind Anjuros Development: 10+ years building software for brands like JD Wetherspoon, Greene King and NEXT, now making simple, professional websites for UK sole traders.",
    RdText.ABOUT_CRUMB to "About",
    RdText.ABOUT_HERO_TITLE_START to "About Anjuros Development: websites for UK ",
    RdText.ABOUT_HERO_TITLE_MARK to "sole traders",
    RdText.ABOUT_HERO_TITLE_END to " and contractors",
    RdText.ABOUT_HERO_LEDE to "I help UK sole traders and contractors get simple, professional websites that attract customers and bring in enquiries. Whether you start from one of my designs or want something fully bespoke, I make getting online easy, without unnecessary complexity.",
    RdText.ABOUT_FACT1_VALUE to "10+ years",
    RdText.ABOUT_FACT1_LABEL to "professional development experience",
    RdText.ABOUT_FACT2_VALUE to "MSc",
    RdText.ABOUT_FACT2_LABEL to "Computer Science",
    RdText.ABOUT_FACT3_VALUE to "UK-based",
    RdText.ABOUT_FACT3_LABEL to "limited company",
    RdText.ABOUT_PROFILE_LABEL to "About the developer",
    RdText.ABOUT_AVATAR_ALT to "Illustrated portrait of Justyna Rosielewska, founder of Anjuros Development",
    RdText.ABOUT_NAME to "Justyna Rosielewska",
    RdText.ABOUT_ROLE to "Founder & developer, Anjuros Development Ltd",
    RdText.ABOUT_BACKGROUND_LABEL to "Background",
    RdText.ABOUT_BACKGROUND to "Android & web development",
    RdText.ABOUT_EDUCATION_LABEL to "Education",
    RdText.ABOUT_EDUCATION to "MSc Computer Science",
    RdText.ABOUT_COMPANY_LABEL to "Company",
    RdText.ABOUT_COMPANY to "No. 16286424",
    RdText.ABOUT_LINKEDIN to "LinkedIn",
    RdText.ABOUT_PORTFOLIO to "Developer portfolio",

    RdText.ABOUT_BRANDS_LABEL to "Brands I have worked on",
    RdText.ABOUT_BRANDS_TITLE to "Contributed to digital products for leading UK brands",
    RdText.ABOUT_BRANDS to "JD Wetherspoon|Greene King|NEXT",
    RdText.ABOUT_QUOTE to "Straightforward, effective websites, without the usual hassle or technical overwhelm.",
    RdText.ABOUT_QUOTE_CAPTION to "Why I founded Anjuros Development",
    RdText.ABOUT_STORY_EYEBROW to "My story",
    RdText.ABOUT_STORY_TITLE to "Helping small businesses get online",
    RdText.ABOUT_WHY_TITLE to "Why I started",
    RdText.ABOUT_WHY_TEXT to "I founded Anjuros Development Limited to give small businesses clean, reliable websites that support the business and bring in more enquiries. No jargon, no complicated systems, and no technical headaches once your website is live.",
    RdText.ABOUT_BACKGROUND_TITLE to "My background",
    RdText.ABOUT_BACKGROUND_TEXT1 to "I’m a UK-based developer with over 10 years of professional experience building reliable, user-friendly software. I’ve worked on commercial digital products for leading UK brands, including JD Wetherspoon, Greene King and NEXT.",
    RdText.ABOUT_BACKGROUND_TEXT2 to "My background is in Android development. I bring the same problem-solving approach to websites, so they’re fast, simple to use and built to perform well.",
    RdText.ABOUT_WHO_TITLE to "Who I work with",
    RdText.ABOUT_WHO_TEXT_START to "Sole traders, contractors and small local businesses, from ",
    RdText.ABOUT_WHO_LINK to "electricians and decorators to bakers and dog walkers",
    RdText.ABOUT_WHO_TEXT_END to ". If you run your business yourself, the website is built around how you work.",
    RdText.ABOUT_WORK_EYEBROW to "Real client project",
    RdText.ABOUT_WORK_STATUS to "Live",
    RdText.ABOUT_WORK_TITLE to "Guesthouse website",
    RdText.ABOUT_WORK_CHALLENGE_LABEL to "Challenge",
    RdText.ABOUT_WORK_CHALLENGE to "No website, only third-party platforms and word of mouth.",
    RdText.ABOUT_WORK_RESULT_LABEL to "Result",
    RdText.ABOUT_WORK_RESULT to "A professional site guests can find, explore and use to get in touch directly.",
    RdText.ABOUT_WORK_TAGS to "Mobile-first|Multi-language|Clear room information|SEO-friendly",
    RdText.ABOUT_WORK_LINK to "View live website",
    RdText.ABOUT_WORK_SHOTS_LABEL to "Screenshots of the guesthouse website",
    RdText.ABOUT_WORK_LAPTOP_ALT to "Guesthouse website on a laptop, showing the rooms section with three room cards",
    RdText.ABOUT_WORK_PHONE_ALT to "Guesthouse website on a phone, showing a double room with balcony",
    RdText.ABOUT_PRINCIPLES_EYEBROW to "Why work with me",
    RdText.ABOUT_PRINCIPLES_TITLE to "Simple, effective and built to last",
    RdText.ABOUT_PRINCIPLES_LEDE to "You won’t get unnecessary features or complicated systems, just a professional website that works for your business.",
    RdText.PRINCIPLE1_TITLE to "Real development experience",
    RdText.PRINCIPLE1_TEXT to "Over 10 years building software, including for major UK brands.",
    RdText.PRINCIPLE2_TITLE to "Properly qualified",
    RdText.PRINCIPLE2_TEXT to "MSc in Computer Science, specialising in Software Development Technologies.",
    RdText.PRINCIPLE3_TITLE to "Clear communication",
    RdText.PRINCIPLE3_TEXT to "A simple process and plain-English updates from first message to launch.",
    RdText.PRINCIPLE4_TITLE to "Built for sole traders",
    RdText.PRINCIPLE4_TEXT to "Websites designed around small businesses, not big-company budgets.",
    RdText.PRINCIPLE5_TITLE to "No technical headaches",
    RdText.PRINCIPLE5_TEXT to "Hosting, security and updates handled, so you can focus on your work.",
    RdText.PRINCIPLE6_TITLE to "Fast and reliable",
    RdText.PRINCIPLE6_TEXT to "Clean code that loads quickly on every phone and keeps working.",
    RdText.ABOUT_SERVICES_EYEBROW to "What I do",
    RdText.ABOUT_SERVICES_TITLE to "Websites and tools for small businesses",
    RdText.SERVICE1_TITLE to "Customised designs",
    RdText.SERVICE1_TEXT to "Pick one of my designs and I’ll tailor it to your business.",
    RdText.SERVICE1_LINK to "See the designs",
    RdText.SERVICE2_TITLE to "Bespoke websites",
    RdText.SERVICE2_TEXT to "A website designed and built from scratch for your brand.",
    RdText.SERVICE2_LINK to "View pricing",
    RdText.SERVICE3_TITLE to "Job Management Portal",
    RdText.SERVICE3_TEXT to "Turn website enquiries into organised jobs automatically.",
    RdText.SERVICE3_LINK to "Explore the portal",
    RdText.SERVICE4_TITLE to "SEO services",
    RdText.SERVICE4_TEXT to "Fast, mobile-friendly websites set up to be found on Google.",
    RdText.SERVICE4_LINK to "SEO services",
    RdText.ABOUT_CLOSE_EYEBROW to "Let’s work together",
    RdText.ABOUT_CLOSE_TITLE to "Ready to get your business online?",
    RdText.ABOUT_CLOSE_LEDE to "Tell me about your business and I’ll suggest the best way to get started.",
    RdText.ABOUT_CLOSE_WORK to "See my work",
    RdText.ABOUT_CLOSE_DESIGNS to "See my designs",

    RdText.SEO_META_TITLE to "SEO Services for Sole Traders | Included With Every Website",
    RdText.SEO_META_DESCRIPTION to "SEO included with every website: keyword research, optimised titles, local SEO, technical setup and fast pages to help UK sole traders rank on Google and get more enquiries.",
    RdText.SEO_CRUMB to "SEO services",
    RdText.SEO_HERO_TITLE_START to "SEO services included with ",
    RdText.SEO_HERO_TITLE_MARK to "every website",
    RdText.SEO_HERO_LEDE to "A website that looks good isn’t enough. It has to be found. Every website I build includes SEO setup, so sole traders get seen on Google and reach the right customers from day one.",
    RdText.SEO_HERO_INCLUDED to "What’s included",
    RdText.SEO_SERP_EXAMPLE to "Example search result",
    RdText.SEO_SERP_TAG to "Your website",
    RdText.SEO_SERP_SITE to "yourbusiness.co.uk",
    RdText.SEO_SERP_NOTES to "Optimised title|Meta description|Local keywords",
    // Each example is: search query ~ result title ~ result description
    RdText.SEO_SERP_EXAMPLE1 to "plumber in Leeds~Plumber in Leeds | Boiler Repairs & Installations~Local, reliable plumbing across Leeds. Emergency callouts, boiler repairs and bathroom installs. Get a free quote today.",
    RdText.SEO_SERP_EXAMPLE2 to "electrician near me~Electrician in Bristol | Rewires, Sockets & EV Chargers~Qualified local electrician covering Bristol and nearby areas. Safe, tidy work and free quotes.",
    RdText.SEO_SERP_EXAMPLE3 to "dog walker Brighton~Dog Walker in Brighton | Daily Walks & Pet Sitting~Friendly, insured dog walking across Brighton and Hove. Solo and group walks, weekdays and weekends.",
    RdText.SEO_SERP_EXAMPLE4 to "wedding cakes Coventry~Celebration Cakes in Coventry | Baked to Order~Handmade wedding and birthday cakes in Coventry. Choose your design and order online.",

    RdText.SEO_TERM to "SEO",
    RdText.SEO_TERM_FULL to "Search engine optimisation",
    RdText.SEO_DEFINE_TITLE to "What SEO means for you",
    RdText.SEO_DEFINE_TEXT to "SEO is the work that helps your website appear higher in search results when potential customers look for services like yours. A well-optimised website helps you compete locally and grow your business.",
    RdText.SEO_INCLUDED_EYEBROW to "Included with every website",
    RdText.SEO_INCLUDED_TITLE to "What’s included in my SEO service",
    RdText.SEO_INCLUDED_LEDE to "Every website comes with this SEO setup as standard. No add-ons, no extra charge.",
    RdText.SEO_CHECK1_TITLE to "Keyword research",
    RdText.SEO_CHECK1_TEXT to "Tailored to your trade and the area you work in.",
    RdText.SEO_CHECK2_TITLE to "Optimised titles & meta descriptions",
    RdText.SEO_CHECK2_TEXT to "So search engines and customers understand each page.",
    RdText.SEO_CHECK3_TITLE to "Proper heading structure",
    RdText.SEO_CHECK3_TEXT to "Clear H1, H2 and H3 headings for readability and ranking.",
    RdText.SEO_CHECK4_TITLE to "Image optimisation",
    RdText.SEO_CHECK4_TEXT to "Compressed images with alt text for speed and accessibility.",
    RdText.SEO_CHECK5_TITLE to "Mobile-friendly design",
    RdText.SEO_CHECK5_TEXT to "Important for Google ranking, and for customers on their phones.",
    RdText.SEO_CHECK6_TITLE to "Technical SEO setup",
    RdText.SEO_CHECK6_TEXT to "Sitemap and robots.txt.",
    RdText.SEO_CHECK7_TITLE to "Local SEO optimisation",
    RdText.SEO_CHECK7_TEXT to "To help you appear in searches in your area.",
    RdText.SEO_CHECK8_TITLE to "Performance & speed",
    RdText.SEO_CHECK8_TEXT to "Fast-loading pages that keep visitors on your site.",
    RdText.SEO_CERT_EYEBROW to "Trained in SEO",
    RdText.SEO_CERT_TITLE to "Up-to-date SEO knowledge",
    RdText.SEO_CERT_TEXT to "I’ve completed professional SEO training, so I follow current best practices and proven techniques. I apply them to every project, so your site is built to be found, not just to look good.",
    RdText.SEO_CERT_COURSE_LABEL to "Course",
    RdText.SEO_CERT_COURSE to "SEO Training Masterclass 2026: Beginner to Advanced SEO",
    RdText.SEO_CERT_LENGTH_LABEL to "Length",
    RdText.SEO_CERT_LENGTH to "19 hours",
    RdText.SEO_CERT_DATE_LABEL to "Completed",
    RdText.SEO_CERT_DATE to "July 2026",
    RdText.SEO_CERT_VERIFY to "Verify certificate",
    RdText.SEO_CERT_ALT to "Certificate of completion for SEO Training Masterclass 2026: Beginner to Advanced SEO",

    RdText.SEO_STATEMENT_EYEBROW to "Why it matters",
    RdText.SEO_STATEMENT_START to "Many sole traders have websites that look good but get no visitors. ",
    RdText.SEO_STATEMENT_MARK to "The difference is SEO.",
    RdText.SEO_STATEMENT_TEXT to "A properly optimised website works around the clock to bring in new customers while you focus on your trade.",
    RdText.SEO_BENEFITS_EYEBROW to "Benefits",
    RdText.SEO_BENEFITS_TITLE to "What SEO does for sole traders",
    RdText.SEO_BENEFIT1_TITLE to "Get found on Google",
    RdText.SEO_BENEFIT1_TEXT to "Rank higher in search results without paying for every click.",
    RdText.SEO_BENEFIT2_TITLE to "Attract local customers",
    RdText.SEO_BENEFIT2_TEXT to "Reach people actively searching for your services in your area.",
    RdText.SEO_BENEFIT3_TITLE to "More enquiries and bookings",
    RdText.SEO_BENEFIT3_TEXT to "More visibility leads to more contact from potential customers.",
    RdText.SEO_BENEFIT4_TITLE to "Trust and credibility",
    RdText.SEO_BENEFIT4_TEXT to "A professional, well-optimised website builds confidence in your business.",
    RdText.SEO_BENEFIT5_TITLE to "Long-term growth",
    RdText.SEO_BENEFIT5_TEXT to "SEO keeps working, unlike short-term paid ads.",
    RdText.SEO_BENEFIT6_TITLE to "Better return on investment",
    RdText.SEO_BENEFIT6_TEXT to "Get more value from the website you already have.",
    RdText.SEO_ONGOING_EYEBROW to "Keep improving",
    RdText.SEO_ONGOING_TITLE to "Want ongoing SEO after launch?",
    RdText.SEO_ONGOING_TEXT to "The Care Plus and Full Service plans include ongoing SEO improvements to help your website keep climbing in search results.",
    RdText.SEO_ONGOING_ITEMS to "Ongoing SEO improvements|Monthly website health check|Speed and performance optimisation",
    RdText.SEO_ONGOING_BUTTON to "Compare plans",

    RdText.SEO_FAQ_TITLE to "SEO questions",
    RdText.SEO_FAQ1_Q to "Is SEO included in the price of my website?",
    RdText.SEO_FAQ1_A to "Yes. Every website includes the SEO setup listed above as standard, at no extra cost.",
    RdText.SEO_FAQ2_Q to "How long does SEO take to work?",
    RdText.SEO_FAQ2_A to "SEO builds over time. Search engines need to find and index your new website, and rankings usually improve gradually over weeks and months rather than overnight.",
    RdText.SEO_FAQ3_Q to "Can you guarantee first place on Google?",
    RdText.SEO_FAQ3_A to "No one can honestly guarantee a top position, because Google decides its own rankings. What I can do is build your website the right way, so it has the best chance of ranking well for your trade and area.",
    RdText.SEO_FAQ4_Q to "Will my website appear in local searches?",
    RdText.SEO_FAQ4_A to "Every website includes local SEO optimisation, such as your trade and area in the right places, to help you show up when people nearby search for your services.",
    RdText.SEO_FAQ5_Q to "Do you offer ongoing SEO?",
    RdText.SEO_FAQ5_A to "Yes. The Care Plus and Full Service plans include ongoing SEO improvements. <a href=\"/website-design-pricing-uk\">See pricing for details</a>.",
    RdText.SEO_CLOSE_EYEBROW to "Ready to get found online?",
    RdText.SEO_CLOSE_TITLE to "A website that looks great and ranks on Google",
    RdText.SEO_CLOSE_LEDE to "Let’s build a website that brings in customers, not just compliments.",

    RdText.PORTAL_META_TITLE to "Job Management Portal for Sole Traders | Manage Jobs, Customers & Payments",
    RdText.PORTAL_META_DESCRIPTION to "A simple Job Management Portal for sole traders. Website enquiries become jobs automatically. Manage clients, scheduling, photos, payments, reviews and statistics in one place.",
    RdText.PORTAL_CRUMB to "Job Management Portal",
    RdText.PORTAL_HERO_TITLE_START to "Job Management Portal for ",
    RdText.PORTAL_HERO_TITLE_MARK to "sole traders",
    RdText.PORTAL_HERO_LEDE to "Run your whole business from one simple portal. Enquiries from your website arrive as jobs automatically, then you manage clients, scheduling, payments and reviews in one place, on your phone or laptop.",
    RdText.PORTAL_HERO_HOW to "See how it works",
    RdText.PORTAL_FREE_BOLD to "2 months free",
    RdText.PORTAL_FREE_TEXT to " with every new website",
    RdText.PORTAL_PHONE_ALT to "Job Management Portal on a phone showing a new enquiry with the customer’s message, phone number and address",
    RdText.PORTAL_EVENT1_TITLE to "New enquiry from your website",
    RdText.PORTAL_EVENT1_TEXT to "Added as a job automatically",
    RdText.PORTAL_EVENT2_TITLE to "“On my way” sent",
    RdText.PORTAL_EVENT2_TEXT to "ETA 15 minutes",
    RdText.PORTAL_EVENT3_TITLE to "Payment request sent",
    RdText.PORTAL_EVENT3_TEXT to "£95.00 by SMS",
    RdText.PORTAL_EVENT4_TITLE to "Review requested",
    RdText.PORTAL_EVENT4_TEXT to "On Google, in one tap",
    RdText.PORTAL_EVENT_STATUSES to "Status: New|On the way|Status: Work done|Status: Paid",

    RdText.PORTAL_JOURNEY_EYEBROW to "How it works",
    RdText.PORTAL_JOURNEY_TITLE to "From first enquiry to 5-star review",
    RdText.PORTAL_JOURNEY_LEDE to "Every tool you need, right where you need it in the job.",
    RdText.PORTAL_JOURNEY_PHONE_CAPTION to "Every action is one tap away from the job.",
    RdText.PORTAL_STAGE1_STATUS to "Status: New",
    RdText.PORTAL_STAGE1_TITLE to "A new enquiry arrives",
    RdText.PORTAL_STAGE1_TEXT to "A customer contacts you through your website and the request lands in your portal as a new job, with their message and details saved.",
    RdText.PORTAL_STAGE1_ACTIONS to "Automatic new job|Client details saved",
    RdText.PORTAL_STAGE2_STATUS to "Status: Contacted",
    RdText.PORTAL_STAGE2_TITLE to "Get in touch and plan the job",
    RdText.PORTAL_STAGE2_TEXT to "Reply quickly and professionally, agree a date and add an estimate.",
    RdText.PORTAL_STAGE2_ACTIONS to "Call client|Reply by email or SMS|Add to calendar|Add estimate|Add note|Edit job",
    RdText.PORTAL_STAGE3_STATUS to "On the day",
    RdText.PORTAL_STAGE3_TITLE to "Head to the job",
    RdText.PORTAL_STAGE3_TEXT to "Let the customer know you’re coming and get directions in one tap.",
    RdText.PORTAL_STAGE3_ACTIONS to "On my way with ETA|Open navigation",
    RdText.PORTAL_STAGE4_STATUS to "Status: Work in progress",
    RdText.PORTAL_STAGE4_TITLE to "Do the work",
    RdText.PORTAL_STAGE4_TEXT to "Log your start time and take before photos to protect your work.",
    RdText.PORTAL_STAGE4_ACTIONS to "Start job|Upload before photos|Change status",
    RdText.PORTAL_STAGE5_STATUS to "Status: Work done",
    RdText.PORTAL_STAGE5_TITLE to "Finish and get paid",
    RdText.PORTAL_STAGE5_TEXT to "Log your finish time, add after photos as proof of completion and send a payment request straight away.",
    RdText.PORTAL_STAGE5_ACTIONS to "Complete job|Upload after photos|Send payment request by SMS|Mark paid",
    RdText.PORTAL_STAGE6_STATUS to "Status: Paid",
    RdText.PORTAL_STAGE6_TITLE to "Win the next job",
    RdText.PORTAL_STAGE6_TEXT to "Turn happy customers into 5-star reviews on Google, Checkatrade, Trustpilot and more, and rebook regulars in seconds.",
    RdText.PORTAL_STAGE6_ACTIONS to "Request review|Repeat job",

    RdText.PORTAL_CLIENTS_EYEBROW to "Clients & insights",
    RdText.PORTAL_CLIENTS_TITLE to "Never lose a customer or a job",
    RdText.PORTAL_CLIENTS_LEDE to "Every client and every job is saved, with photos, notes, costs and history. See how your business is doing at a glance.",
    RdText.PORTAL_CLIENTS_IMAGE_ALT to "Client history in the portal showing past jobs for a customer, with photos, notes, cost and job duration",
    RdText.PORTAL_STAT1_TITLE to "Client logs",
    RdText.PORTAL_STAT1_TEXT to "All clients and their job history in one place",
    RdText.PORTAL_STAT2_TITLE to "Monthly jobs",
    RdText.PORTAL_STAT2_TEXT to "See how many jobs you complete each month",
    RdText.PORTAL_STAT3_TITLE to "Hours worked",
    RdText.PORTAL_STAT3_TEXT to "Logged automatically when you start and finish",
    RdText.PORTAL_STAT4_TITLE to "Paid & unpaid",
    RdText.PORTAL_STAT4_TEXT to "Know exactly what’s still owed to you",
    RdText.PORTAL_BENEFITS_EYEBROW to "Why sole traders love it",
    RdText.PORTAL_BENEFITS_TITLE to "Less admin. More jobs. More time for the work that pays.",
    RdText.PORTAL_BENEFIT1_TITLE to "Jobs created automatically",
    RdText.PORTAL_BENEFIT1_TEXT to "Website enquiries appear in your dashboard instantly.",
    RdText.PORTAL_BENEFIT2_TITLE to "Spend less time on admin",
    RdText.PORTAL_BENEFIT2_TEXT to "Manage every job from one simple dashboard.",
    RdText.PORTAL_BENEFIT3_TITLE to "Get paid faster",
    RdText.PORTAL_BENEFIT3_TEXT to "Send payment requests instantly and track what’s outstanding.",
    RdText.PORTAL_BENEFIT4_TITLE to "Win more 5-star reviews",
    RdText.PORTAL_BENEFIT4_TEXT to "Request reviews in one tap and build your reputation.",
    RdText.PORTAL_BENEFIT5_TITLE to "Stay organised every day",
    RdText.PORTAL_BENEFIT5_TEXT to "Jobs, customers, notes, photos and schedules together.",
    RdText.PORTAL_BENEFIT6_TITLE to "Grow your business",
    RdText.PORTAL_BENEFIT6_TEXT to "Track your workload, hours worked and performance.",
    RdText.PORTAL_GET_EYEBROW to "How to get it",
    RdText.PORTAL_GET_TITLE to "Included with the Full Service plan, free for 2 months",
    RdText.PORTAL_GET_LEDE to "Every new website includes the first 2 months of the Full Service plan for free.",
    RdText.PORTAL_STEP_LABEL to "Step %d",
    RdText.PORTAL_GET1_TITLE to "Your website goes live",
    RdText.PORTAL_GET1_TEXT to "I build and launch your professional website.",
    RdText.PORTAL_GET2_TITLE to "2 months of Full Service, free",
    RdText.PORTAL_GET2_TEXT to "Enjoy the Full Service plan at no cost for your first 2 months.",
    RdText.PORTAL_GET3_TITLE to "Manage every job in one place",
    RdText.PORTAL_GET3_TEXT to "Get full access to the Job Management Portal and run your business with less admin.",
    RdText.PORTAL_GET_FOOT to "No setup cost. No hidden extras.",
    RdText.PORTAL_GET_COMPARE to "Compare plans",
    RdText.PORTAL_FAQ_TITLE to "Portal questions",
    RdText.PORTAL_FAQ1_Q to "Is the Job Management Portal included with my website?",
    RdText.PORTAL_FAQ1_A to "The portal is part of the Full Service plan. Every new website includes the first 2 months of Full Service for free.",
    RdText.PORTAL_FAQ2_Q to "Do website enquiries appear in the portal automatically?",
    RdText.PORTAL_FAQ2_A to "Yes. When a customer fills in your website’s <a href=\"/contact-forms\">contact form</a>, the enquiry appears in your portal as a new job straight away.",
    RdText.PORTAL_FAQ3_Q to "Can I use it on my phone?",
    RdText.PORTAL_FAQ3_A to "Yes. The portal works on your phone and laptop, so you can manage jobs at home or on site.",
    RdText.PORTAL_FAQ4_Q to "Which review sites can I send customers to?",
    RdText.PORTAL_FAQ4_A to "You can request reviews on Google, Checkatrade, Trustpilot and more with one tap.",
    RdText.PORTAL_FAQ5_Q to "What happens after the 2 free months?",
    RdText.PORTAL_FAQ5_A to "You can stay on Full Service, or switch to another plan. You can upgrade, downgrade or cancel at any time. <a href=\"/website-design-pricing-uk\">See pricing for details</a>.",
    RdText.PORTAL_CLOSE_EYEBROW to "Get started today",
    RdText.PORTAL_CLOSE_TITLE to "A website that brings in jobs, and a portal to run them",
    RdText.PORTAL_CLOSE_LEDE to "Your first 2 months of Full Service are free with every new website.",

    RdText.PRICING_META_TITLE to "Website Design Pricing UK | Affordable Websites for Sole Traders",
    RdText.PRICING_META_DESCRIPTION to "Simple, transparent website design pricing for UK sole traders: customised websites £99 one-off, bespoke from £149, care plans from £9.99 a month. No upfront payment.",
    RdText.PRICING_CRUMB to "Pricing",
    RdText.PRICING_HERO_TITLE_START to "Website design pricing for ",
    RdText.PRICING_HERO_TITLE_MARK to "UK sole traders",
    RdText.PRICING_HERO_LEDE to "Simple, transparent pricing for professional websites, fully customised for your business. A one-off build fee, then a monthly plan that keeps your website online, secure and up to date. No hidden costs.",
    RdText.PRICING_FACT_WEBSITE_LABEL to "Your website · one-off fee",
    RdText.PRICING_FACT_WEBSITE_BOLD to "No upfront payment.",
    RdText.PRICING_FACT_WEBSITE_TEXT to " Pay the build fee only once you’re happy with your finished website.",
    RdText.PRICING_FACT_PLAN_LABEL to "Your care plan · monthly",
    RdText.PRICING_FACT_PLAN_BOLD to "First 2 months of Full Service free.",
    RdText.PRICING_FACT_PLAN_TEXT to " After that, upgrade, downgrade or cancel your plan at any time.",

    RdText.PRICING_BUILDER_LABEL to "Build your quote",
    RdText.PRICING_STEP1_EYEBROW to "Step 1 · One-off",
    RdText.PRICING_STEP1_TITLE to "Choose your website",
    RdText.PRICING_STEP2_EYEBROW to "Step 2 · Monthly",
    RdText.PRICING_STEP2_TITLE to "Choose your care plan",
    RdText.PRICING_STEP2_TEXT to "A care plan is needed with every website to keep it secure, updated, supported and live. Pay monthly or annually, and upgrade, downgrade or cancel at any time.",
    RdText.PRICE_FROM to "from",
    RdText.PRICE_ONE_OFF to "one-off",
    RdText.PRICE_PER_MONTH to "/month",
    RdText.PRICE_PER_MONTH_SHORT to "/mo",
    RdText.WEBSITE_CUSTOM_BADGE to "Fast & affordable",
    RdText.WEBSITE_CUSTOM_TITLE to "Customised website design",
    RdText.WEBSITE_CUSTOM_PRICE to "£99",
    RdText.WEBSITE_CUSTOM_TEXT to "Choose one of my proven designs and I’ll customise it with your content, images, colours and branding.",
    RdText.WEBSITE_CUSTOM_FEATURES to "Your content added, with help creating anything missing|Custom domain setup and website launch|Mobile-friendly and optimised for all devices|Contact form designed for your business",
    RdText.WEBSITE_CUSTOM_LINK to "See all designs →",
    RdText.WEBSITE_BESPOKE_BADGE to "Unique design",
    RdText.WEBSITE_BESPOKE_TITLE to "Fully bespoke website",
    RdText.WEBSITE_BESPOKE_PRICE to "£149",
    RdText.WEBSITE_BESPOKE_TEXT to "A website designed and built from scratch to your exact requirements.",
    RdText.WEBSITE_BESPOKE_FEATURES to "Tailored to your brand, layout and goals|Complete setup including domain and launch|Optimised for mobile and all devices|Contact form designed for your business",
    RdText.PLAN_BASIC_TITLE to "Basic Care",
    RdText.PLAN_BASIC_PRICE to "£9.99",
    RdText.PLAN_BASIC_TEXT to "Keep your website online and running smoothly.",
    RdText.PLAN_BASIC_FEATURES to "Domain renewal|Reliable web hosting|SSL certificate (HTTPS)|Regular backups|Security monitoring|Software updates|Enquiries sent to your email|Pay-as-you-go updates from £10",
    RdText.PLAN_PLUS_TITLE to "Care Plus",
    RdText.PLAN_PLUS_PRICE to "£19.99",
    RdText.PLAN_PLUS_TEXT to "Keep your website fresh with regular updates and SEO.",
    RdText.PLAN_PLUS_FEATURES to "Up to 3 updates a month (text, images, new reviews and more)|Ongoing SEO improvements|Monthly health check|Speed optimisation",
    RdText.PLAN_FULL_BADGE to "Includes Job Portal",
    RdText.PLAN_FULL_TITLE to "Full Service",
    RdText.PLAN_FULL_PRICE to "£39.99",
    RdText.PLAN_FULL_TEXT to "Grow your business with less admin.",
    RdText.PLAN_FULL_FEATURES to "Job Management Portal|Enquiries become organised jobs|Review and payment requests|Up to 5 updates a month (text, images, new reviews and more)|Priority support",
    RdText.PLAN_EVERYTHING_IN_BASIC to "Everything in Basic Care",
    RdText.PLAN_EVERYTHING_IN_PLUS to "Everything in Care Plus",
    RdText.QUOTE_TITLE to "QUOTE",
    RdText.QUOTE_SUBTITLE to "Your website, priced",
    RdText.QUOTE_WEBSITE_NOTE to "One-off, paid once you’re happy",
    RdText.QUOTE_FREE_LINE to "Full Service, first 2 months",
    RdText.QUOTE_FREE to "FREE",
    RdText.QUOTE_FREE_NOTE to "Included with every new website",
    RdText.QUOTE_PLAN_NOTE to "From month 3. Cancel any time",
    RdText.QUOTE_DUE_TODAY to "Due today",
    RdText.QUOTE_DUE_AMOUNT to "£0.00",
    RdText.QUOTE_SUMMARY_FULL to "Pay %website once you’re happy with your website. Full Service is free for 2 months, then %price a month.",
    RdText.QUOTE_SUMMARY_OTHER to "Pay %website once you’re happy with your website. You get Full Service free for your first 2 months, then %plan at %price a month.",

    RdText.PRICING_COMPARE_EYEBROW to "Compare care plans",
    RdText.PRICING_COMPARE_TITLE to "Website maintenance and support for UK sole traders",
    RdText.PRICING_COMPARE_COLUMN to "What’s included",
    RdText.PRICING_COMPARE_NOTE to "Prices shown per month. Pay monthly or annually. Upgrade, downgrade or cancel at any time.",
    RdText.PRICING_NOT_INCLUDED to "Not included",
    RdText.COMPARE_GROUP_ONLINE to "Keep it online",
    RdText.COMPARE_GROUP_GROWING to "Keep it growing",
    RdText.COMPARE_GROUP_BUSINESS to "Run your business",
    RdText.COMPARE_DOMAIN to "Domain renewal",
    RdText.COMPARE_HOSTING to "Web hosting",
    RdText.COMPARE_SSL to "SSL certificate (HTTPS)",
    RdText.COMPARE_BACKUPS to "Regular backups",
    RdText.COMPARE_SECURITY to "Security monitoring & software updates",
    RdText.COMPARE_ENQUIRIES to "Contact form enquiries to your email",
    RdText.COMPARE_UPDATES to "Included website updates (text, images, new reviews and more)",
    RdText.COMPARE_UPDATES_BASIC to "Paid per update",
    RdText.UPDATE_PRICES_LABEL to "See prices for updates on the Basic plan",
    RdText.UPDATE_PRICES_CLOSE to "Close update prices",
    RdText.UPDATE_PRICES_TITLE to "Basic plan updates",
    RdText.UPDATE_PRICES_LEDE to "Once your website is live, you only pay for the updates you ask for.",
    RdText.UPDATE_PRICES_ROWS to "Change text, prices, opening hours or contact details;£10|Add or replace an image;£10|Add new reviews;£10|Add a service to your services list;£10|New section, such as a gallery, special offer or FAQ;£20|New page;from £40",
    RdText.UPDATE_PRICES_NOTE to "One update is one change in one place, such as replacing a photo or rewording a paragraph. Need regular changes? Care Plus includes 3 updates a month for £10 more.",
    RdText.COMPARE_UPDATES_PLUS to "Up to 3 / month",
    RdText.COMPARE_UPDATES_FULL to "Up to 5 / month",
    RdText.COMPARE_SEO to "Ongoing SEO improvements",
    RdText.COMPARE_HEALTH to "Monthly website health check",
    RdText.COMPARE_SPEED to "Speed & performance optimisation",
    RdText.COMPARE_PORTAL to "Job Management Portal",
    RdText.COMPARE_JOBS to "Enquiries become organised jobs",
    RdText.COMPARE_RECORDS to "Customers, notes, photos & schedules",
    RdText.COMPARE_REQUESTS to "Review & payment requests",
    RdText.COMPARE_SUPPORT to "Priority support",
    RdText.PRICING_INCLUDED_EYEBROW to "Every website",
    RdText.PRICING_INCLUDED_TITLE to "Included whichever option you choose",
    RdText.PRICING_INCLUDED_LEDE to "All websites are customised with your own text, photos, colours and branding.",
    RdText.PRICING_INC1_TITLE to "Your content added",
    RdText.PRICING_INC1_TEXT to "Missing something? I’ll help you create it.",
    RdText.PRICING_INC2_TITLE to "Domain and launch",
    RdText.PRICING_INC2_TEXT to "Custom domain set up and your website launched for you.",
    RdText.PRICING_INC3_TITLE to "Mobile-friendly",
    RdText.PRICING_INC3_TEXT to "Optimised for phones, tablets and desktops.",
    RdText.PRICING_INC4_TITLE to "Custom contact form",
    RdText.PRICING_INC4_TEXT to "Designed around your business. ",
    RdText.PRICING_INC4_LINK to "Learn more",
    RdText.PRICING_FAQ_TITLE to "Pricing questions",
    RdText.PRICING_FAQ1_Q to "Do I have to pay upfront?",
    RdText.PRICING_FAQ1_A to "No. You only pay the one-off website fee once you’re happy with the finished website.",
    RdText.PRICING_FAQ2_Q to "Why do I need a monthly care plan?",
    RdText.PRICING_FAQ2_A to "A care plan keeps your website secure, updated, supported and live. It covers hosting, domain renewal, SSL and backups, so you never have to think about them.",
    RdText.PRICING_FAQ3_Q to "Can I change or cancel my plan?",
    RdText.PRICING_FAQ3_A to "Yes. You can upgrade, downgrade or cancel your plan at any time.",
    RdText.PRICING_FAQ4_Q to "Can I pay annually?",
    RdText.PRICING_FAQ4_A to "Yes. Care plans can be paid monthly or annually.",
    RdText.PRICING_FAQ5_Q to "What’s the difference between a customised and a bespoke website?",
    RdText.PRICING_FAQ5_A to "A customised website starts from one of my designs and is tailored with your content, colours and branding. A bespoke website is designed and built from scratch to your exact requirements.",
    RdText.PRICING_CLOSE_EYEBROW to "No upfront payment",
    RdText.PRICING_CLOSE_TITLE to "See your website first, pay when you’re happy",
    RdText.PRICING_CLOSE_LEDE to "Tell me about your business and I’ll prepare a free preview.",

    RdText.FORMS_META_TITLE to "Custom Contact Forms for Small Business Websites | Included With Every Website",
    RdText.FORMS_META_DESCRIPTION to "Custom contact forms included with every website. Built around your business with any fields you need, sent straight to your email, with Cloudflare Turnstile spam protection.",
    RdText.FORMS_CRUMB to "Contact forms",
    RdText.FORMS_HERO_TITLE_START to "Custom contact forms included with ",
    RdText.FORMS_HERO_TITLE_MARK to "every website",
    RdText.FORMS_HERO_LEDE to "Professional contact forms, built around your business and included in the price of every website. Make it easy for customers to get in touch, and never miss an enquiry again.",
    RdText.FORMS_HERO_DEMO to "Try a demo form",
    RdText.FORMS_FLOW_LABEL to "How contact forms work",
    RdText.FORMS_FLOW1_TITLE to "A visitor fills in your form",
    RdText.FORMS_FLOW1_TEXT to "On your website, on any device.",
    RdText.FORMS_FLOW2_TITLE to "The form is submitted",
    RdText.FORMS_FLOW2_TEXT to "Checked for spam before it’s sent.",
    RdText.FORMS_FLOW3_TITLE to "The enquiry reaches your inbox",
    RdText.FORMS_FLOW3_TEXT to "Delivered straight to your email.",
    RdText.FORMS_FLOW4_TITLE to "You respond",
    RdText.FORMS_FLOW4_TEXT to "Contact the customer and arrange the work.",

    RdText.FORMS_DEMO_EYEBROW to "Contact form examples",
    RdText.FORMS_DEMO_TITLE to "Try a form, see the enquiry you’d receive",
    RdText.FORMS_DEMO_LEDE to "Pick an example, change the answers and watch the email update. Every form can be customised with any fields, field types and options at no extra cost.",
    RdText.FORMS_DEMO_TABS_LABEL to "Example contact forms",
    RdText.FORMS_SPAM_NOTE to "Spam protection is enabled on live websites to block bots. ",
    RdText.FORMS_SPAM_LINK to "Learn more",
    RdText.FORMS_DEMO_SUBMIT to "Submit (demo)",
    RdText.FORMS_DEMO_SENT to "Demo only: on your website, this enquiry would now be in your inbox.",
    RdText.INBOX_LABEL to "Email preview",
    RdText.INBOX_TITLE to "Your inbox",
    RdText.INBOX_EXAMPLE to "Example enquiry",
    RdText.INBOX_SUBJECT to "New enquiry from your website",
    RdText.INBOX_TO to "To: %s · Just now",
    RdText.INBOX_NOT_ANSWERED to "Not answered",
    RdText.INBOX_FOOT_START to "With the ",
    RdText.INBOX_FOOT_LINK to "Full Service plan",
    RdText.INBOX_FOOT_END to ", every enquiry also becomes a job in your portal.",
    RdText.FIELD_NAME to "Name",
    RdText.FIELD_EMAIL to "Email",
    RdText.FIELD_PHONE to "Phone number",
    RdText.FIELD_MESSAGE to "Message",
    RdText.FIELD_NOTE to "Note",
    RdText.DEMO_NAME to "Sarah Jones",
    RdText.DEMO_EMAIL to "sarah.jones@example.com",
    RdText.DEMO_PHONE to "07700 900123",
    RdText.DEMO_GENERAL_TAB to "Simple",
    RdText.DEMO_GENERAL_TITLE to "Get in touch",
    RdText.DEMO_GENERAL_KIND to "Simple form",
    RdText.DEMO_GENERAL_BUSINESS to "Your business",
    RdText.DEMO_GENERAL_MESSAGE to "Hi, could you give me a call about a job next week?",
    RdText.DEMO_ELEC_TAB to "Electrician",
    RdText.DEMO_ELEC_TITLE to "Request a quote",
    RdText.DEMO_ELEC_KIND to "Electrician form",
    RdText.DEMO_ELEC_BUSINESS to "Smith Electrical",
    RdText.DEMO_ELEC_TYPE to "Type of work",
    RdText.DEMO_ELEC_TYPE_OPTIONS to "Emergency electrical fault|Consumer unit / fuse board upgrade|Electrical inspection (EICR)|Rewiring|Additional sockets|Lighting installation|Outdoor / garden lighting|EV charger installation|Smoke alarms|Landlord electrical certificate|Commercial electrical work|Other",
    RdText.DEMO_ELEC_TYPE_VALUE to "Additional sockets",
    RdText.DEMO_ELEC_MESSAGE to "Two extra double sockets in the living room, please.",
    RdText.DEMO_HAIR_TAB to "Hairdresser",
    RdText.DEMO_HAIR_TITLE to "Book an appointment",
    RdText.DEMO_HAIR_KIND to "Hairdresser form",
    RdText.DEMO_HAIR_BUSINESS to "Studio Lily",
    RdText.DEMO_HAIR_MESSAGE to "Cut and colour, please. Mornings work best.",
    RdText.DEMO_HAIR_DATE to "Preferred appointment date",
    RdText.DEMO_HAIR_DATE_VALUE to "2026-10-24",
    RdText.DEMO_PLUMB_TAB to "Plumber",
    RdText.DEMO_PLUMB_TITLE to "Book a plumber",
    RdText.DEMO_PLUMB_KIND to "Plumber form",
    RdText.DEMO_PLUMB_BUSINESS to "Leeds Plumbing",
    RdText.DEMO_PLUMB_MESSAGE to "Leaking pipe under the kitchen sink.",
    RdText.DEMO_PLUMB_URGENCY to "Urgency",
    RdText.DEMO_PLUMB_URGENCY_OPTIONS to "ASAP|Within a week|Flexible",
    RdText.DEMO_PLUMB_URGENCY_VALUE to "ASAP",
    RdText.DEMO_DECO_TAB to "Decorator",
    RdText.DEMO_DECO_TITLE to "Get a decorating quote",
    RdText.DEMO_DECO_KIND to "Decorator form",
    RdText.DEMO_DECO_BUSINESS to "Jones Decorating",
    RdText.DEMO_DECO_AREAS to "Which areas need work?",
    RdText.DEMO_DECO_AREAS_OPTIONS to "Living room|Bedroom|Kitchen|Bathroom|Hallway / landing|Stairs|Ceilings|Doors & frames|Skirting boards|Exterior walls|Fence / shed|Entire property",
    RdText.DEMO_DECO_AREAS_VALUE to "Living room|Hallway / landing|Stairs",
    RdText.DEMO_DECO_WORK to "What work is needed?",
    RdText.DEMO_DECO_WORK_OPTIONS to "Painting|Wallpaper hanging|Wallpaper removal|Surface preparation|Crack repairs|Filling holes|Woodwork painting|Exterior decorating",
    RdText.DEMO_DECO_WORK_VALUE to "Painting|Woodwork painting",
    RdText.DEMO_DECO_MESSAGE to "Looking to refresh the hallway before Christmas.",
    RdText.DEMO_BAKE_TAB to "Baker",
    RdText.DEMO_BAKE_TITLE to "Order a bake",
    RdText.DEMO_BAKE_KIND to "Baker form",
    RdText.DEMO_BAKE_BUSINESS to "Little Crumb",
    RdText.DEMO_BAKE_WHAT to "What can I bake for you?",
    RdText.DEMO_BAKE_WHAT_OPTIONS to "Birthday cake|Wedding cake|Cupcakes|Cookies|Tarts|Other",
    RdText.DEMO_BAKE_WHAT_VALUE to "Birthday cake",
    RdText.DEMO_BAKE_NOTE to "Chocolate cake for 20 people, Saturday the 14th.",

    RdText.FORMS_FIELDS_EYEBROW to "Fully customisable",
    RdText.FORMS_FIELDS_TITLE to "Ask for exactly what you need to quote",
    RdText.FORMS_FIELDS_LEDE to "Every business is different, so your form is built around your work. Choose from a wide range of field types.",
    RdText.FORMS_FIELDS_LABEL to "Available field types",
    RdText.FIELD_TYPE_TEXT to "Text fields",
    RdText.FIELD_TYPE_TEXT_SAMPLE to "Full name",
    RdText.FIELD_TYPE_EMAIL to "Email fields",
    RdText.FIELD_TYPE_EMAIL_SAMPLE to "name@example.com",
    RdText.FIELD_TYPE_PHONE to "Phone fields",
    RdText.FIELD_TYPE_PHONE_SAMPLE to "07700 900123",
    RdText.FIELD_TYPE_AREA to "Text areas",
    RdText.FIELD_TYPE_AREA_SAMPLE to "Tell me about the job…",
    RdText.FIELD_TYPE_SELECT to "Dropdowns",
    RdText.FIELD_TYPE_SELECT_SAMPLE to "Type of work",
    RdText.FIELD_TYPE_DATE to "Date pickers",
    RdText.FIELD_TYPE_DATE_SAMPLE to "24/10/2026",
    RdText.FIELD_TYPE_CHECK to "Checkboxes",
    RdText.FIELD_TYPE_CHECK_SAMPLE to "Kitchen",
    RdText.FIELD_TYPE_RADIO to "Radio buttons",
    RdText.FIELD_TYPE_RADIO_SAMPLE to "ASAP",
    RdText.FORMS_BENEFITS_EYEBROW to "Why it matters",
    RdText.FORMS_BENEFITS_TITLE to "Contact forms designed to help you win more work",
    RdText.FORMS_BENEFITS_LEDE to "Collect the information you need, receive enquiries straight to your inbox, and never miss a potential customer.",
    RdText.FORMS_BENEFIT1_TITLE to "Included in every package",
    RdText.FORMS_BENEFIT1_TEXT to "A custom form comes with every website at no extra cost.",
    RdText.FORMS_BENEFIT2_TITLE to "Built for your business",
    RdText.FORMS_BENEFIT2_TEXT to "Fields and options chosen around the jobs you do.",
    RdText.FORMS_BENEFIT3_TITLE to "Unlimited field types",
    RdText.FORMS_BENEFIT3_TEXT to "Add as many fields and options as you need.",
    RdText.FORMS_BENEFIT4_TITLE to "Straight to your email",
    RdText.FORMS_BENEFIT4_TEXT to "Every enquiry is delivered directly to your inbox.",
    RdText.FORMS_BENEFIT5_TITLE to "Easy to complete",
    RdText.FORMS_BENEFIT5_TEXT to "Clear, mobile-friendly forms that customers actually finish.",
    RdText.FORMS_BENEFIT6_TITLE to "Never miss an enquiry",
    RdText.FORMS_BENEFIT6_TEXT to "Customers can get in touch any time, even while you’re on a job.",
    RdText.FORMS_SPAM_EYEBROW to "Spam protection",
    RdText.FORMS_SPAM_TITLE to "Real enquiries in, spam bots out",
    RdText.FORMS_SPAM_TEXT1 to "Automated bots target website forms with unwanted messages. Every website includes professional spam protection powered by Cloudflare Turnstile, which checks that a visitor is a real person without annoying puzzles.",
    RdText.FORMS_SPAM_TEXT2 to "Less spam, a protected inbox, and genuine customer messages that reach you.",
    RdText.FORMS_SPAM_LIST_TITLE to "Included with every care plan",
    RdText.FORMS_SPAM_LIST to "Cloudflare Turnstile human verification|Protection against automated spam|Server-side validation for extra security|Fast, user-friendly experience|Ongoing setup and integration",
    RdText.FORMS_FAQ_TITLE to "Contact form questions",
    RdText.FORMS_FAQ1_Q to "Is a contact form included with my website?",
    RdText.FORMS_FAQ1_A to "Yes. A custom contact form is included with every website at no extra cost.",
    RdText.FORMS_FAQ2_Q to "Can I choose which questions customers answer?",
    RdText.FORMS_FAQ2_A to "Yes. Your form can use any fields, field types and options you need, such as dropdowns, date pickers, checkboxes and radio buttons.",
    RdText.FORMS_FAQ3_Q to "Where do enquiries go?",
    RdText.FORMS_FAQ3_A to "Straight to your email. With the Full Service plan, they also appear in your Job Management Portal as new jobs.",
    RdText.FORMS_FAQ4_Q to "Will I get spam through my form?",
    RdText.FORMS_FAQ4_A to "Every website includes spam protection powered by Cloudflare Turnstile, plus server-side validation, to block bots and keep your inbox for genuine customers.",
    RdText.FORMS_CLOSE_EYEBROW to "Get started",
    RdText.FORMS_CLOSE_TITLE to "A website with a contact form built for your work",
    RdText.FORMS_CLOSE_LEDE to "Tell me what you need to know from customers and I’ll build it in.",
    RdText.FORMS_CLOSE_PRICING to "View pricing",

    // Blog
    RdText.BLOG_META_TITLE to "Business Tips for UK Sole Traders | SEO, Websites & Marketing",
    RdText.BLOG_META_DESCRIPTION to "Discover practical business advice for UK sole traders. Learn how to get more customers, improve your Google rankings, build a professional website and grow your business.",
    RdText.BLOG_CRUMB to "Blog",
    RdText.BLOG_HERO_TITLE_START to "Business & marketing guides for ",
    RdText.BLOG_HERO_TITLE_MARK to "tradesmen",
    RdText.BLOG_HERO_LEDE to "Practical guides to help UK sole traders get more customers, improve their online presence, rank higher on Google, save time and grow their business with confidence.",
    RdText.BLOG_TOPICS_LABEL to "Topics",
    RdText.BLOG_TOPICS to "Websites|Local SEO|Getting customers",
    RdText.BLOG_LATEST to "Latest guide",
    RdText.BLOG_LATEST_READ to "Read the guide",
    RdText.BLOG_READ_TIME to "%d min read",
    RdText.BLOG_GUIDES_EYEBROW to "Start here",
    RdText.BLOG_GUIDES_TITLE to "Guides, in the order that helps most",
    RdText.BLOG_GUIDES_LEDE to "New to getting your business online? Read them in order: why a website matters, what it needs, what it should cost, then how to bring in more customers.",
    RdText.BLOG_INSIDE to "Inside",
    RdText.BLOG_READ_ARTICLE to "Read article",
    RdText.BLOG_TOPIC_WEBSITES to "Websites",
    RdText.BLOG_TOPIC_CUSTOMERS to "Getting customers",
    RdText.BLOG_WHY_WEBSITE_ALT to "Laptop showing a sole trader website on a workshop desk",
    RdText.BLOG_WHY_WEBSITE_INSIDE to "Customers search online first|Works even when you don’t|Website vs social media",
    RdText.BLOG_FEATURES_ALT to "Handyman website open on a laptop and a phone on a desk",
    RdText.BLOG_FEATURES_INSIDE to "A clear headline|Areas you cover|Local SEO|Clear calls to action",
    RdText.BLOG_CUSTOMERS_ALT to "Tradesman shaking hands with a customer at the front door",
    RdText.BLOG_CUSTOMERS_INSIDE to "Google Business Profile|Asking for reviews|Replying quickly|Common mistakes",
    RdText.BLOG_COST_ALT to "Laptop showing website prices on a workshop bench, with a calculator and a notebook of website costs",
    RdText.BLOG_COST_INSIDE to "Website builders vs designers|Hidden costs|What you should pay|How my pricing compares",
    RdText.BLOG_CLOSE_EYEBROW to "Put it into practice",
    RdText.BLOG_CLOSE_TITLE to "Want a website that does all this for you?",
    RdText.BLOG_CLOSE_LEDE to "Every website I build is mobile-first, set up for Google and makes it easy for customers to get in touch.",
    RdText.BLOG_CLOSE_DESIGNS to "See the designs",
    RdText.BLOG_WHY_WEBSITE_META_TITLE to "Why Every Sole Trader Needs a Website | Get More Customers",
    RdText.BLOG_WHY_WEBSITE_META_DESCRIPTION to "Discover why every UK sole trader needs a professional website. Learn how a website helps you get found on Google, build trust and win more customers.",
    RdText.BLOG_FEATURES_META_TITLE to "15 Features Every Trades Website Should Have | Get More Enquiries",
    RdText.BLOG_FEATURES_META_DESCRIPTION to "Discover 15 essential features every trades website should have, from local SEO and reviews to before and after photos, quote forms and clear contact options.",
    RdText.BLOG_CUSTOMERS_META_TITLE to "How Sole Traders Can Get More Customers | 10 Proven Tips",
    RdText.BLOG_CUSTOMERS_META_DESCRIPTION to "Looking for ways to get more customers as a sole trader? Discover 10 practical strategies including local SEO, Google Business Profile, customer reviews and a professional tradesmen website design.",
    RdText.BLOG_COST_META_TITLE to "How Much Does a Website Cost for a Sole Trader? | UK Prices 2026",
    RdText.BLOG_COST_META_DESCRIPTION to "How much should a UK sole trader pay for a website? Compare DIY builders, WordPress, freelancers and agencies, the hidden costs to watch for and the best value option.",
    RdText.BLOG_BY_START to "By ",
    RdText.BLOG_BY_NAME to "Justyna",
    RdText.BLOG_BY_END to ", founder of Anjuros Development",
    RdText.BLOG_TOC_TITLE to "On this page",
    RdText.BLOG_GET_IN_TOUCH to "Get in touch",
    RdText.BLOG_MORE_EYEBROW to "Keep reading",
    RdText.BLOG_MORE_TITLE to "More guides",
    RdText.TABLE_SWIPE to "Swipe to see the whole table",
    RdText.FAQS_META_TITLE to "Website design FAQ for UK sole traders | Pricing, process & more",
    RdText.FAQS_META_DESCRIPTION to "Common questions about website design for UK sole traders. Learn about pricing, timelines, and how the process works.",
    RdText.FAQS_CRUMB to "FAQ",
    RdText.FAQS_HERO_TITLE_START to "Website design FAQ for UK ",
    RdText.FAQS_HERO_TITLE_MARK to "sole traders",
    RdText.FAQS_HERO_LEDE to "Answers to common questions about website design, pricing, and how the process works for UK sole traders and small businesses.",
    RdText.FAQS_SEARCH_LABEL to "Search the questions",
    RdText.FAQS_SEARCH_PLACEHOLDER to "Search the questions, e.g. domain",
    RdText.FAQS_TOPICS_LABEL to "Topics",
    RdText.FAQS_NO_RESULTS_START to "No questions match your search. ",
    RdText.FAQS_NO_RESULTS_LINK to "Ask me directly",
    RdText.FAQS_NO_RESULTS_END to " and I’ll get back to you.",
    RdText.FAQS_TOPIC_START to "Getting started",
    RdText.FAQS_TOPIC_WEBSITE to "Your website",
    RdText.FAQS_TOPIC_SEO to "Google & SEO",
    RdText.FAQS_TOPIC_ENQUIRIES to "Enquiries & Job Management Portal",
    RdText.FAQS_TOPIC_ENQUIRIES_SHORT to "Enquiries & Job Portal",
    RdText.FAQS_TOPIC_PLANS to "Plans & support",
    RdText.FAQS_LINK_TRADES to "Trades I work with →",
    RdText.FAQS_LINK_DESIGNS to "Browse the designs →",
    RdText.FAQS_LINK_WHY_WEBSITE to "Why every sole trader needs a website →",
    RdText.FAQS_LINK_SEO to "More about SEO services →",
    RdText.FAQS_LINK_FORMS to "About contact forms →",
    RdText.FAQS_LINK_PORTAL to "More about the Job Management Portal →",
    RdText.FAQS_LINK_PRICING to "Prices and plan details →",
    RdText.FAQS_Q1 to "What types of businesses do you build websites for?",
    RdText.FAQS_A1 to "I specialise in websites for UK sole traders, including plumbers, electricians, builders, handymen, decorators, gardeners, cleaners and many other local service businesses. I also create websites for small businesses, charities, community organisations and professional portfolios.",
    RdText.FAQS_Q2 to "How long does it take to build my website?",
    RdText.FAQS_A2 to "Most websites based on one of my designs are ready within a few days of receiving your content. Fully bespoke websites or additional features may take longer depending on the project. I will keep you updated throughout the process.",
    RdText.FAQS_Q3 to "Can you redesign my existing website?",
    RdText.FAQS_A3 to "Yes. Whether you have an outdated website or simply want a more modern design, I can redesign your existing website while keeping your business information, branding and goals in mind. I can also improve its speed, SEO and user experience.",
    RdText.FAQS_Q4 to "Can I keep my existing domain name?",
    RdText.FAQS_A4 to "Yes. If you already own a domain name, it can usually be connected to your new website. If you don't have one, I can help you choose and register a suitable domain name for your business.",
    RdText.FAQS_Q5 to "Why does a sole trader need a website?",
    RdText.FAQS_A5 to "A professional website helps potential customers find your business online, view your services, read reviews, see previous work and contact you easily. Unlike social media, your website is your own online presence that you control and can use to generate enquiries 24/7. Read more in <a href=\"/blog/why-every-sole-trader-needs-a-website\">why every sole trader needs a website</a>.",
    RdText.FAQS_Q6 to "Can a website help me get more customers?",
    RdText.FAQS_A6 to "Yes. A professional website builds trust, improves your visibility on Google and gives potential customers an easy way to contact you. Combined with SEO, customer reviews and a fast, mobile-friendly design, your website can become one of your most valuable sources of new enquiries.",
    RdText.FAQS_Q7 to "Will my website work on mobile phones and tablets?",
    RdText.FAQS_A7 to "Yes. Every website is fully responsive and designed to work smoothly on mobile phones, tablets and desktop computers. It is also tested to provide a great experience across modern devices.",
    RdText.FAQS_Q8 to "Do I need technical knowledge to manage my website?",
    RdText.FAQS_A8 to "No. I take care of the technical side, including hosting, maintenance, security updates and SEO.",
    RdText.FAQS_Q9 to "Will my website appear on Google?",
    RdText.FAQS_A9 to "Yes. Your website will be visible on Google and is built using SEO best practices, including proper page structure, meta information, mobile optimisation and fast loading times. This helps search engines find and index your website. Every website also includes SEO to help improve your visibility on Google over time.",
    RdText.FAQS_Q10 to "Do you provide SEO?",
    RdText.FAQS_A10 to "Yes. SEO is included with every website. This includes technical SEO, search engine optimisation, ongoing improvements and guidance to help your business appear higher in local search results.",
    RdText.FAQS_Q11 to "Can customers contact me directly from my website?",
    RdText.FAQS_A11 to "Yes. Your website includes professional contact forms that send enquiries directly to you. If you choose the Full Service plan, every enquiry is also automatically added to your private Job Management Portal, helping you keep track of new jobs without any manual work.",
    RdText.FAQS_Q12 to "Can customers book jobs online?",
    RdText.FAQS_A12 to "Yes. Customers can send enquiries through your website at any time using your contact forms. Every enquiry is delivered directly to your email, regardless of which plan you choose. If you have the Full Service plan, every enquiry is also automatically added to your Job Management Portal, making it quick and easy to follow up, schedule work and manage your jobs.",
    RdText.FAQS_Q13 to "What is the Job Management Portal?",
    RdText.FAQS_A13 to "The Job Management Portal is a private online space designed specifically for sole traders. It allows you to manage enquiries, contact customers, schedule jobs, upload before and after photos, request reviews, send payment requests, record job duration and keep all your work organised from your phone or computer.",
    RdText.FAQS_Q14 to "What happens after my website is finished?",
    RdText.FAQS_A14 to "Your website remains online and supported with one of our maintenance plans, so you can choose the level of support that best suits your business. Basic Care includes secure hosting, domain renewal, an SSL certificate, regular backups, security monitoring and contact form delivery to your email. Care Plus adds ongoing website updates and regular SEO improvements to help increase your visibility on Google. Full Service includes everything in Care Plus, plus priority support and access to your private Job Management Portal, allowing you to manage enquiries, jobs, reviews and customer communications from your phone or computer. You can upgrade or change your plan at any time as your business grows.",
    RdText.FAQS_CLOSE_EYEBROW to "Still have a question?",
    RdText.FAQS_CLOSE_TITLE to "Didn’t find your answer?",
    RdText.FAQS_CLOSE_LEDE to "Get in touch and I’ll answer your questions and help you choose the right website for your business.",
    RdText.FAQS_CLOSE_PRICING to "See pricing",
    RdText.COPY_EMAIL_LABEL to "Copy email address",
    RdText.COPY_WHATSAPP_LABEL to "Copy WhatsApp number",
    RdText.COPY_DONE to "Copied",
)

/** The redesign is English-only for now, so every language falls back to the English texts. */
val RdTextResources: Map<Language, Map<RdText, String>> = Language.entries.associateWith { EnglishTexts }

/** Splits a list text written as "a|b|c" into its items. */
fun rdList(text: String): List<String> = text.split("|")
